import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Modal as AntModal } from 'antd';
import {
  updateQuoteAdmin,
  downloadPdf,
  sendQuotationToCustomerEmail,
  fetchQuoteByRefId,
  getallAddressAdmin,
  fetchQuoteByIdForQuoteVersion,
  newCheckout,
  updateQuoteShipMethod,
  handleQuoteCancel,
  moveQuoteToProgressStatus,
  updateQuoteAdminComment,
  updateQuotationNotesAndTnc,
  handleMarkAsSend,
  handleCommonAddAddressForUser,
  handleCommonDeleteAddressForUser,
  handleCommonEditAddressForUser,
  processFileWithAnalysis,
  getUserAddressAdmin,
} from "../../utils/actions/allactions";
import {
  numberInputOnWheelPreventChange,
  currencyFormatter,
  replaceSpacesWithUnderscore,
  isValidFileName,
  // downloadFileFromS3,
} from "../../utils/helper";
import downloadFileFromS3 from "../../utils/helper";
import { fetchRFQForQuotation } from "../../utils/actions/supplierActions";
import {
  createRFQ,
  cancelRFQForQuotation,
} from "../../utils/actions/supplierActions";
import { useParams, useNavigate, Link } from "react-router-dom";
import Sidebar from "../Sidebar";
import { toast } from "react-toastify";
import _ from "lodash";
import downloadImg from "../../images/download.svg";
import deleteImageEnabled from "../../images/reddelete.svg";
import { MAX_FILE_SIZE_BYTES, maxFileUploadSize, processType, quoteVersionDescriptions } from "../../utils/constant";
import { Modal, Button, Row, Col, Form, FormControl } from "react-bootstrap";
import ChatButton from "../../Chat/ChatButton";
import Chat from "../../Chat";
import { ChatRefContext } from "../../context/chatRef.context";
import moment from "moment";
import useDocumentTitle from "../../utils/useDocumentTitle";
import AddressModal from "../../components/CommanAddressModal/AddressModal";
import CaptchaModal from "../../components/CaptchaModal/CaptchaModal";
import TeamCollaboration from "../../components/TeamCollaboration/TeamCollaboration";
import { activateTargetCostForUser, getAllCncCertifications, getAllMachineDataWithPopulation, getAllTechnology, getAllthreeDCertifications, getSalesOrdersForAllQuotation } from "../../utils/actions/adminActions";
import { getAllCertifications, handleProjectNameChange, uploadThreeDFile, uploadTwoDFile } from "../../utils/actions/commanActions";
import { Loading } from "../../components/Loading";
import { ArrowDown, ArrowUp, DeleteIcon, DownloadIcon, EditIcon, EyeIcon, LucidLoader, UploadIcon } from "../../components/Icons";
import { CrossIcon } from "../../components/GlobalProjectNameComponent";
import { addBillingAddress, deleteBillingAddress, fetchOrganzationDetails, getBillingAddressById, getData, getDFMInfo, getUserBillingAddressByUserId, updateBillingAddress } from "../../api/customer/masters/commonMastersApi";
import ReactQuill from 'react-quill';
import CertificationModal from "../../components/CertificationModal/CertificationModal";
import { downloadQuotationPdf } from "../../api/customer/quotation/commonQuotationApi";
import AdminCertificationComponent from "../../components/AdminCertificationsComponent/AdminCertificationComponent";
import { changeLoggedStatus } from "../../api/customer/quotation/userQuotationApi";
import LoggingModalComponent from "../LoggingModalComponent/LoggindModalComponent";
import PartMetadataChangeComponent from "../../components/PartMetadataChangeComponent/PartMetadataChangeComponent";
import EditProjectName from "../../components/EditProjectName/EditProjectName";
import ThreeDViewerComponent from "../../components/ViewerComponent/ThreeDViewerComponent";
import { deletePartSnapShotData, uploadPartSnapShotData } from "../../api/customer/quotation/adminQuotationApi";
import GenericAddressComponent from "../../components/GenericAddressComponent/GenericAddressComponent";
import BatchDownloadButton from "../../components/BatchDownloadButton/BatchDownloadButton";
import { useInstance } from "../../context/instance.context";
import EmailRecordModal from "../../components/EmailRecord/EmailRecordModal";
import FileName from "../../components/FileNameWithDownloadAndDelete/FileNameWithDownloadAndDelete";
import { useUnsavedChanges } from "../../context/UnsavedChangesContext";
import GenericLoaderComponent from "../Loading/GenericLoaderComponent";
import PDFModalViewer from "../../components/PDFViewerModal/PDFModalViewer";
import { getPresignedUrlForFile } from "../../api/helperapi/helperApi";
import AdminLoadingComponent from "../../components/LoadingComponents/AdminLoadingComponent";
import WithDragAndDrop from "../../components/DragAndDrop/DragAndDropButton";
import AutoResizingTextarea from "../../components/AutoResizeTextAreaComponent/AutoResizeTextAreaComponent";

const AdminQuote = () => {
  let { _id } = useParams();
  let navigate = useNavigate();
  let token = localStorage.getItem("Token");
  const [leadTime, setLeadTime] = useState([]);
  const [shippingDays, setShippingDays] = useState([]);
  const [selectedQuote, setSelectedQuote] = useState();
  const [allVersionForRefId, setAllVersionForRefId] = useState([]);
  const [selectedShipMethod, setSelectedShipMethod] = useState("");
  const [isDfmLoading, setIsDfmLoading] = useState(false);
  let [showModal, setShowModal] = useState(false);
  const [showFollowerModal, setShowFollowerModal] = useState(false);
  const [teamLoading, setTeamLoading] = useState(false);
  const [emailRecordLoading, setEmailRecordLoading] = useState(false);
  const handleClose = () => {
    setVersionDescriptionValue("");
    setShowModal(false);
  };
  const [isBatchFileDownloading, setIsBatchFileDownloading] = useState(false);
  const [isPoLoaderActivated, setIsPoLoaderActivated] = useState(false);
  const [downloadQuoteModalError, setDownloadQuoteModalError] = useState('');
  const [showEmailRecords, setShowEmailRecords] = useState(false);
  const [isTwoDFileUploading, setIsTwoDFileUploading] = useState(false);
  const [isThreeDFileUploading, setIsThreeFileUploading] = useState(false);
  const [quoteRefId, setQuoteRefId] = useState('');
  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  })
  const { isDirty, setIsDirty } = useUnsavedChanges();
  const [isAnyUnsavedChanges, setIsAnyUnsavedChanges] = useState(false);
  useEffect(() => {
    setIsDirty(isAnyUnsavedChanges);
  }, [isAnyUnsavedChanges]);
  useEffect(() => {
    fetchAllQoutesForRefId();
    fetchSupplierData();
  }, [_id]);


  // const trimToTwoDecimals = (val) => {
  //   if (val == null || Number.isNaN(val)) return null;
  //   return Math.trunc(val * 100) / 100; // truncate toward 0
  // };
  const trimToTwoDecimals = (val) => {
    if (val == null || Number.isNaN(val)) return null;
    const neg = val < 0;
    const [i, f = ""] = String(Math.abs(val)).split(".");
    const out = i + (f ? "." + f.slice(0, 2) : "");
    return Number(neg ? "-" + out : out);
  };



  const ErrorCheckHOF = (fn) => {
    return (...arg) => {
      if (isAnyUnsavedChanges) {
        toast.error("You have unsaved changes. Please save or discard them before proceeding.");
        return;
      }
      fn(...arg);
    }

  }

  const handleShowEmailRecordsClick = async () => {

    try {
      if (!showEmailRecords) {
        setEmailRecordLoading(true);
        const res = await getData([
          {
            "modelName": "quotes",
            "fields": ["quoteEmailRecord"],
            "filter": { "_id": _id },
          },
        ], 'getdata data for email records');
        if (!res?.success) {
          toast.error("Unable to fetch email records");
          return;
        };
        const data = res?.results?.quotes[0]?.quoteEmailRecord;
        setSelectedQuote((pre) => {
          return {
            ...pre,
            quoteEmailRecord: data,
          };
        });
      }


      setShowEmailRecords((pre) => !pre);


    } catch (error) {
      toast.error('Failed to fetch email records');
    } finally {
      setEmailRecordLoading(false);
    }


  }

  const batchRef = useRef();
  const handleExternalDownload = async () => {
    try {
      setIsBatchFileDownloading(true);
      await batchRef.current?.triggerDownload();

    } catch (error) {
      toast.error("Failed to download batch file at the moment");
    } finally {
      setIsBatchFileDownloading(false);
    }
  };
  const { name, allInstanceData, organizationName: organizationNameData, quotationTncData, quotationNotesData } = useInstance();

  useEffect(() => {
    if (organizationNameData) {
      setOrganizationName(organizationNameData);
      setTermsAndTncFromOrg({
        tnc: quotationTncData,
        notes: quotationNotesData
      });
    }
  }, [organizationNameData, quotationTncData, quotationNotesData]);



  const [certificationsBasedOnSelectedProcess, selectedCertificationsBasedOnSelected] = useState(false);
  const [isLogged, setIsLogged] = useState(false);
  const [poModalError, setPoModalErrors] = useState("");

  const [open, setOpen] = useState(false);
  const { setSelectedChatRefId, selectedChatRefId, setChatType } =
    useContext(ChatRefContext);
  const [poDocument, setPoDocument] = useState(null);
  const [poNumber, setPoNumber] = useState("");
  const [showSoModal, setShowSoModal] = useState(false);
  const [linesTotal, setLinesTotal] = useState([]);
  const [versionDescriptionValue, setVersionDescriptionValue] = useState("");
  const [rFQForQuotation, setRFQForQuotation] = useState(null);
  const [salesOrder, setSalesOrder] = useState({});
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [billingAddressForUser, setBillingAddressForUser] = useState([]);
  const [isNoBillingAddressSelected, setIsNoBillingAddressSelected] = useState(false);
  const [isChanged, setIsChanged] = useState({
    quotationNotes: false,
    partInfo: false,
    leadtime: false,
    shippingCharge: false,
    shippingDays: false,
    certifications: false,
  });
  const [isQuotationDownloading, setQuotationDownloading] = useState(false);
  const [isCaptchaModalForAskTargetCost, setIsCaptchModalForAskTargetCost] = useState(false);
  const [showGenericModal, setShowGenericModal] = useState(false);

  const [showDQModal, setShowDQModal] = useState(false);
  const [functionalityForDQ, setFunctionalityForDQ] = useState("");
  const [quotationNotes, setQuotationNotes] = useState("");
  const [allOrdersForProject, setAllOrdersForProject] = useState([]);
  const [quotationTnc, setQuotationTnc] = useState("");
  const [isNoShippingAddressSelected, setIsNoShippingAddressSelected] = useState(false);
  const [isLoggedModalOpen, setIsLoggedModalOpen] = useState(false);
  const [editBillingAddressId, setEditBillingAddressId] = useState('');
  const [isSecondaryDataLoading, setIsSecondaryLoading] = useState(false);
  const [isDfmDataLoading, setIsDfmDataLoading] = useState(false);

  // New state for address selected for quotation download
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const [showProjectNameModal, setShowProjectNameModal] = useState(false);
  const [addressValues, setAddressValues] = useState({});
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    companyName: "",
    vatNumber: "",
    addresses: "",
    finalTotalPrice: "",
    addressline1: "",
    addressline2: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
    subTotal: "",
  });
  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [isEditingProjectName, setIsEditingProjectName] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCostUpdatedbyAdminWhenTargetCostIsAvailable, setIsCostUpdatedByAdminWhenTargetCostIsAvailable] = useState(false);
  const [isCertificationsModalOpen, setIsCertificationModalOpen] = useState(false);
  const [editableProjectName, setEditableProjectName] = useState('');
  const [showSendtoSupplierModal, setShowSendtoSupplierModal] = useState(false);
  const [allCncMachineData, setAllCncMachineData] = useState(null);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  const [organizationName, setOrganizationName] = useState('');
  const [termsAndTncFromOrg, setTermsAndTncFromOrg] = useState({ tnc: '', notes: '' });
  const [reload, setReload] = useState(false);
  useDocumentTitle("Quote Details");
  const versionScrollRef = useRef({});
  const preVersion = useRef("");
  const hasScrolled = useRef(false);
  useEffect(() => {
    if (!selectedQuote) return;
    if (!hasScrolled.current || (selectedQuote?._id && preVersion.current != selectedQuote?.version && versionScrollRef[selectedQuote?._id])) {
      preVersion.current = selectedQuote.version;
      hasScrolled.current = true;
      versionScrollRef[selectedQuote?._id]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

  }, [_id, selectedQuote]);


  const userSelectCostRef = useRef(false);

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const [responseFromAllTechnology, responseFromMachineData] = await Promise.all([getAllTechnology(), getAllMachineDataWithPopulation()]);
        setMasterThreeDTechnologyData(responseFromAllTechnology.data);
        setAllCncMachineData(responseFromMachineData.data);


      } catch (error) {
        console.error('Error ::', error);
      }
    };
    fetchMasterData();
  }, []);

  const addBillingAddressFunction = async (data) => {
    try {
      const response = await addBillingAddress({ ...data, userId: selectedQuote.userId._id });
      if (response.success) {
        toast.success("Billing address added successfully");
        setShowGenericModal(false);
        setReload((pre) => !pre);
      };

    } catch (error) {
      console.error("Error :", error);
      throw new Error('unable to add billing address');
    }
  };

  const getBillingAddressByid = async (id) => {
    try {
      const data = await getBillingAddressById(id);
      if (data.success) {
        return data?.billingAddress || null;
      }
    } catch (error) {

    }
  };
  const billingAddressUpdateFunction = async (id, data) => {
    try {
      const response = await updateBillingAddress(id, data);
      if (response.success) {
        toast.success("Billing address added successfully");
        setShowGenericModal(false);
        setReload((pre) => !pre);
      };
    }
    catch (error) {
      throw new Error('unable to update billing address');
    }

  };
  const deleteBilllingAddress = async (id) => {
    try {
      if (id) {
        const response = await deleteBillingAddress(id);
        if (response.success) {
          setReload((pre) => !pre);
        }

      }


    } catch (error) {
      console.error("Error in profile  211 on " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        error
      );
    }

  }
  const handleEditBillingAddress = (id) => {
    setEditBillingAddressId(id);
    setShowGenericModal(true);
  }

  useEffect(() => {
    if (selectedQuote?.userId?._id) {
      getUserBillingAddressByUserId(selectedQuote?.userId?._id).then((res) => {
        if (res.success) {
          setBillingAddressForUser(res.billingAddress);
        }
      })
    }

  }, [selectedQuote?.userId?._id, reload]);

  const addNewBillingAddress = () => {
    setEditBillingAddressId(null);
    setShowGenericModal(true);
  };





  useEffect(() => {
    const isEmptyHtml = (html) => {
      if (!html) return true;
      const cleaned = html.replace(/<[^>]*>/g, '').trim();
      return cleaned === '';
    };

    if (!isEmptyHtml(selectedQuote?.quotationTnc)) {
      setQuotationTnc(selectedQuote.quotationTnc);
    } else {
      setQuotationTnc(termsAndTncFromOrg.tnc);
    }
    if (selectedQuote?.quotationNotes) {
      setQuotationNotes(selectedQuote.quotationNotes);

    }

  }, [
    selectedQuote?.quotationTnc,
    selectedQuote?.quotationNotes,
    termsAndTncFromOrg?.tnc,
    termsAndTncFromOrg?.notes
  ]);




  useEffect(() => {
    (async () => {
      try {

        if (selectedQuote?.selectedProcess == 1) {
          //cnc cert
          const response = await getAllCncCertifications();
          const { data } = response;
          selectedCertificationsBasedOnSelected(data);
        }
        else if (selectedQuote?.selectedProcess == 2) {
          //3d cert
          const response = await getAllthreeDCertifications();
          const { data } = response;
          selectedCertificationsBasedOnSelected(data);
        }
        else {
          //manual Process
          const response = await getAllCertifications();
          const { data } = response;
          selectedCertificationsBasedOnSelected(data);
        }
      } catch (error) {
        console.error("Failed to fetch certifications");
      }

    })();

  }, [selectedQuote?.selectedProcess]);
  const handleTargetCostAsk = async () => {
    if (!selectedQuote) {
      toast.error("Quotation not found");
      return;
    }
    try {
      setIsLoading(true);
      setIsCaptchModalForAskTargetCost(false);

      const response = await activateTargetCostForUser(token, selectedQuote?._id);

      if (!response || !response?.success) {
        throw new Error();
      };
      const { updatedEmailRecords } = response;
      if (Array.isArray(updatedEmailRecords)) {
        setSelectedQuote((pre) => {
          return {
            ...pre,
            quoteEmailRecord: updatedEmailRecords,
          }
        })
      }
      toast.success(`Email sent to user for target cost`);
      fetchAllQoutesForRefId();

    } catch (error) {
      toast.error("Unable to ask target cost ");
    } finally {
      setIsLoading(false);
    }

  }

  const handleEditClick = () => {
    let project = { ...selectedQuote };
    const firstUnderscoreIndex = project.projectName.indexOf("_");
    const editableText = project.projectName.substring(
      firstUnderscoreIndex + 1
    );

    setSelectedQuote({
      ...selectedQuote,
      previousProjectName: selectedQuote.projectName,
      editableProjectName: editableText,
    });

    setIsEditingProjectName(true);
  };

  const handleEditableChange = (e) => {
    const { value } = e.target;
    setSelectedQuote({ ...selectedQuote, editableProjectName: value });
  };

  const handle2DFileUpload = async (e, index) => {
    try {
      const file = e.target.files[0];

      if (!file) {
        return;
      }

      if (!_id) {
        toast.error("Invalid quotation. Please refresh the page and try again.");
        return;
      }

      const fileSizeInMB = file.size / (1024 * 1024);

      if (file.size < 1024 || fileSizeInMB > 100) {
        toast.error("File size must be between 1 KB and 100 MB.");
        return;
      };

      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("quoteId", _id);
      formData.append("indexOfPartsData", index);
      const response = await uploadTwoDFile(formData);

      if (!response || !response.success) {
        toast.error("Failed to upload file. Please try again.");
        return;
      };
      toast.success("File uploaded successfully");

      const { data } = response;

      setSelectedQuote((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item, indexOfItem) => {
            if (indexOfItem == index) {
              return {
                ...item,
                twoDFile: data,
              }
            } else {
              return item;
            }
          })
        }
      });

    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const handle3DFileUpload = async (e, index) => {
    console.log('Event in file upload ::', e);
    console.log('Index ::', index);
    try {
      //add checks
      if (!_id) {
        toast.error("Invalid quotation. Please refresh the page and try again.");
        return;
      }
      const file = e.target.files[0];
      if (!file) {
        toast.error("No file uploaded");
        return;
      }
      if (file.size > MAX_FILE_SIZE_BYTES) {
        toast.error("File excluded: size exceeds the 100MB limit.");
        return;

      }
      if (file.name.toLowerCase().endsWith('.stl')) {
        toast.error('Unsupported file type. Please upload STP or STEP files');
        return;
      }
      setIsLoading(true);

      //now get qr date
      const isFileNameValid = isValidFileName(file?.name || file?.path);
      if (!isFileNameValid) {
        //just upload the file 
        const formData = new FormData();
        formData.append("file", file);
        formData.append("quoteId", _id);
        formData.append("indexOfPartsData", index);
        const response = await uploadThreeDFile(formData);
        const { data } = response;
        setSelectedQuote((pre) => {
          return {
            ...pre,
            partsData: pre.partsData.map((item, indexOfItem) => {
              if (indexOfItem == index) {
                return {
                  ...item,
                  selectedFile: data,
                  thumbnail: null,
                  s3QrFileUrl: null,
                  jsonFileUrl: null,
                  gltfPlainFileUrl: null,
                  gltfColoredFileUrl: null,
                  stagingPartsDataId: null,
                  partFileName: file?.path || file?.name,
                }
              } else {
                return item;
              }
            })
          }
        });
        return;
      };
      const responseFromQR = await processFileWithAnalysis(file);
      if (!responseFromQR.status) {
        toast.error(`Failed to analyze file: ${file?.name || file?.path}`);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("quoteId", _id);
        formData.append("indexOfPartsData", index);
        const response = await uploadThreeDFile(formData);
        const { data } = response;
        setSelectedQuote((pre) => {
          return {
            ...pre,
            partsData: pre.partsData.map((item, indexOfItem) => {
              if (indexOfItem == index) {
                return {
                  ...item,
                  selectedFile: data,
                  thumbnail: null,
                  s3QrFileUrl: null,
                  jsonFileUrl: null,
                  gltfPlainFileUrl: null,
                  gltfColoredFileUrl: null,
                  stagingPartsDataId: null,
                  partFileName: file?.path || file?.name,
                }
              } else {
                return item;
              }
            })
          }
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("quoteId", _id);
      formData.append("indexOfPartsData", index);

      const dataReceivedFromResponse = responseFromQR.data?.result;
      const analysisData = {
        s3QrFileUrl: dataReceivedFromResponse?.filesS3Data || null,
        jsonFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[0]?.json || null,
        thumbnail: dataReceivedFromResponse?.quaoarResponseFiles?.[1]?.png || null,
        gltfPlainFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[2]?.glb?.[0] || null,
        gltfColoredFileUrl: dataReceivedFromResponse?.quaoarResponseFiles?.[2]?.glb?.[1] || null,
        stagingPartsDataId: dataReceivedFromResponse?.stagingPartResponse?._id || "",
      };
      formData.append("analysisData", JSON.stringify(analysisData));
      const response = await uploadThreeDFile(formData);
      const { data, stagingData = {} } = response;

      if (!response || !response.success) {
        toast.error("Failed to upload file. Please try again.");
        return;
      };

      setSelectedQuote((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item, indexOfItem) => {
            if (indexOfItem == index) {
              return {
                ...item,
                selectedFile: data,
                ...analysisData,
                ...stagingData,
              }
            } else {
              return item;
            }
          })
        }
      });

    } catch (err) {
      console.error("Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteFile = async (type, index) => {
    //prompt confirmation
    const confirmed = await new Promise((resolve) => {
      AntModal.confirm({
        title: `Delete ${type} File`,
        content: `Are you sure you want to delete this ${type} file?`,
        okText: "Yes, Delete",
        cancelText: "Cancel",
        okType: "danger",
        centered: true,
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (!confirmed) return;

    if (type == '2D') {
      setSelectedQuote((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item, indexOfItem) => {
            if (indexOfItem == index) {
              return {
                ...item,
                twoDFile: null,
              }
            } else {
              return item;
            }
          })
        }
      });

    }
    else if (type == '3D') {
      setSelectedQuote((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item, indexOfItem) => {
            if (indexOfItem == index) {
              return {
                ...item,
                selectedFile: null,
                thumbnail: null,
                s3QrFileUrl: null,
                jsonFileUrl: null,
                gltfPlainFileUrl: null,
                gltfColoredFileUrl: null,
                stagingPartsDataId: null,
                partFileName: null,
              }
            } else {
              return item;
            }
          })
        }
      });
    }

  }

  const handleUpdateClick = async (value) => {
    let data = {
      RefId: selectedQuote.RefId,
      projectName: value,
    };

    const response = await handleProjectNameChange(token, data);
    if (response.success) {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
    setSelectedQuote((pre) => {
      return { ...pre, projectName: value }
    });
    setShowProjectNameModal(false);
  };

  const handleCancelClick = () => {
    setIsEditingProjectName(false);
    setSelectedQuote({ ...selectedQuote, editableProjectName: "" });
  };

  const handleCloseCaptchaModal = () => setShowCaptchaModal(false);

  const handledAddAddress = async (addressData) => {
    let data = {
      userId: selectedQuote.userId._id,
      addressData,
    };
    const response = await handleCommonAddAddressForUser(token, data);
    if (response.status) {
      let localAllUserAddress = addressValues?.address
        ? [...addressValues.address]
        : [];
      localAllUserAddress.push(response.data);
      setAddressValues({ ...addressValues, address: localAllUserAddress });
      setShowDQModal(true);
    };
  };
  const handleAddressOnEdit = async (newFormData, index) => {
    let allAddresses = addressValues.address ? addressValues.address : [];
    let address = allAddresses[index];
    address = { ...address, ...newFormData };
    const response = await handleCommonEditAddressForUser(token, address);
    if (response.status) {
      allAddresses[index] = response.data;
      let addressValueData = {};
      if (addressValues.shippingAddress == response.data._id) {
        addressValueData = {
          addressline1: response.data.addressLineOne,
          addressline2: response.data.addressLineTwo,
          city: response.data.city,
          country: response.data.country,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          state: response.data.state,
          zipCode: response.data.postalCode,
        };
      }
      setAddressValues({
        ...addressValues,
        ...addressValueData,
        address: allAddresses,
      });
      setShowDQModal(true);
    }
  };

  const addNewHandler = () => {
    setShowAddressModal(true);
  };

  const editHandler = (index) => {
    setShowAddressModal(true);
    setIsEdit(true);
    setEditId(index);
    setShowDQModal(false);
  };

  const deleteData = async (i) => {
    if (i > -1) {
      const addressToDelete = addressValues.address[i];
      let localAllAddress = addressValues?.address
        ? [...addressValues.address]
        : [];
      const addressDeleteResponse = await handleCommonDeleteAddressForUser(
        token,
        addressToDelete._id
      );
      if (addressDeleteResponse.status) {
        localAllAddress.splice(i, 1);
        setAddressValues({ ...addressValues, address: localAllAddress });
      }
    }
  };

  const handleUpdateQuotationNotesAndTnc = async () => {
    try {
      let data = {
        quoteId: selectedQuote._id,
        quotationNotes,
        quotationTnc,
      };

      const response = await updateQuotationNotesAndTnc(token, data);
      if (response.status) {
        toast.success(response.message);
        setSelectedQuote({
          ...selectedQuote,
          quotationNotes: response?.data?.quotationNotes,
          quotationTnc: response?.data?.quotationTnc,
        });
        setIsChanged({ ...isChanged, quotationNotes: false });
      }
    } catch (err) {
      console.error(
        "Error in admin quote 137 on: " +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleProjectNameSave = (value) => {
    setSelectedQuote((pre) => {
      return { ...pre, projectName: value };
    });
    setShowProjectNameModal(false);

  };
  const handleSnapShotUpload = async (e, id, isSnapshotExists) => {
    if (isSnapshotExists) {
      let adminResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Upload snapshot?',
          content: (
            <>
              <p>Are you sure you want to upload a new snapshot?</p>
              <p style={{ color: 'red', marginTop: 10 }}>
                Warning: This action will permanently replace the existing snapshot. The old snapshot cannot be recovered.
              </p>
            </>
          ),
          okText: 'Yes, Upload',
          cancelText: 'Cancel',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!adminResponse) return;

    }





    const file = e.target.files[0];
    const MAX_FILE_SIZE_MB = 10;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
    if (!file) return;
    if (file.size > MAX_FILE_SIZE_BYTES) {
      toast.error(`File size exceeds ${MAX_FILE_SIZE_MB} MB limit.`);
      return;
    }
    if (!file.type.startsWith("image/")) {
      toast.error("Only image files are allowed.");
      return;
    }


    if (!selectedQuote?._id) {
      toast.error("Please select a quote to upload snapshot.");
      return;
    }
    const formData = new FormData();
    formData.append("snapshot", file);
    formData.append("item_id", id);
    formData.append("quoteId", selectedQuote?._id);
    try {
      setIsLoading(true);

      const response = await uploadPartSnapShotData(formData, selectedQuote?.RefId, selectedQuote?.version);
      if (!response.success) {
        throw new Error();
      }
      const { url } = response;
      setSelectedQuote((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item) => {
            if (item._id == id) {
              return {
                ...item,
                thumbnail: url
              }
            } else {
              return item;
            }
          })
        }
      });




    } catch (error) {
      toast.error("Unable to upload snapshot at the moment.");
    }
    finally {
      setIsLoading(false);

    }

  }
  const handleDeleteSnapshot = async (id) => {

    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Delete Snapshot?',
        content: (
          <>
            <p>Are you sure you want to delete this snapshot?</p>
            <p style={{ color: 'red', marginTop: 10 }}>
              Warning: This action will permanently delete the current snapshot and it cannot be recovered.
            </p>
          </>
        ),
        okText: 'Yes, Delete',
        cancelText: 'Cancel',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

    if (!adminResponse) return;


    const data = {
      item_id: id,
      quoteId: selectedQuote?._id,
    }
    try {
      setIsLoading(true);

      const response = await deletePartSnapShotData(data);
      if (!response.success) {
        throw new Error();
      }
      setSelectedQuote((pre) => {
        return {
          ...pre,
          partsData: pre.partsData.map((item) => {
            if (item._id == id) {
              return {
                ...item,
                thumbnail: ''
              }
            } else {
              return item;
            }
          })
        }
      });




    } catch (error) {
      toast.error("Unable to upload snapshot at the moment.");
    }
    finally {
      setIsLoading(false);

    }

  }

  const handleTeamModalShow = async () => {
    setShowFollowerModal(true);
  };

  const handlePoModalClose = () => {
    setShowSoModal(false);
  };

  const handlePoDocumentDelete = () => {
    setPoDocument(null);
  };

  const showDrawer = () => {
    setOpen(true);
    setSelectedChatRefId(selectedQuote.RefId);
    setChatType("customer");
  };

  const onClose = () => {
    setOpen(false);
    setChatType(null);
    setSelectedChatRefId(null);
  };



  useEffect(() => {
    let line1Total = 0;
    let line2Total = 0;
    let line3Total = 0;

    selectedQuote?.partsData?.forEach((item, idx) => {
      console.log(`${idx + 1} : Qty :${item.Qty} Price : ${item.price1}`)
      line1Total += Number(item.Qty || 0) * parseFloat(item.price1 || 0);
      line2Total += Number(item.Qty || 0) * parseFloat(item.price2 || 0);
      line3Total += Number(item.Qty || 0) * parseFloat(item.price3 || 0);
    });

    setLinesTotal([line1Total, line2Total, line3Total]);
  }, [selectedQuote]);

  useEffect(() => {
    if (userSelectCostRef.current) return;
    const activePrices = linesTotal
      .map((price, idx) => ({ price, value: idx + 1 }))
      .filter(item => item.price);


    if (activePrices.length === 1) {
      const newMethod = Number(activePrices[0].value);
      setSelectedShipMethod(newMethod);

      setSelectedQuote(prev => {
        if (prev.selectedShipMethod === newMethod) return prev;
        return { ...prev, selectedShipMethod: newMethod };
      });

    } else if (activePrices.length > 1) {
      setSelectedShipMethod('');
      setSelectedQuote(prev => {
        if (prev.selectedShipMethod === '') return prev;
        return { ...prev, selectedShipMethod: '' };
      });
    }
  }, [linesTotal]);

  const fetchUserAddress = useCallback(async (userId) => {
    try {
      const address = await getUserAddressAdmin(token, userId);
      setAddressValues((pre) => ({
        ...pre,
        address,
      }));

    } catch (error) {
      console.error("Error fetching user address:", error);
    }

  }, []);




  useEffect(() => {
    if (selectedQuote?.userId?._id) {
      fetchUserAddress(selectedQuote?.userId?._id);
    };
  }, [selectedQuote?.userId?._id, fetchUserAddress])




  const fetchSupplierData = async () => {
    try {
      const fetchRFQResponse = await fetchRFQForQuotation(_id, token);
      if (fetchRFQResponse.data.status) {
        setRFQForQuotation(fetchRFQResponse?.data.data);
      }
    } catch (err) {
      console.error(
        "err in admin quote 283 on" +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };



  const fetchDataForSelectedQuote = async (id) => {
    try {
      const res = await getData([
        {
          "modelName": "quotes",
          "fields": ["selectedProcess"],
          "filter": { "_id": (id || _id) },
        },
      ], 'getdata quote selectedprocess');
      if (!res.success) return;
      const selectedProcess = res?.results?.quotes[0]?.selectedProcess;
      let selectedQuoteDetails = { data: { data: null } };
      if (selectedProcess == 1) {
        const res = await getData([
          {
            modelName: 'quotes',
            fields: [''],
            "filter": { "_id": (id || _id) },
            "populate": [
              {
                path: 'followers',
                select: '_id firstName lastName email companySiteId userCompanySite',
                populate: {
                  path: 'companySiteId',
                  select: '_id domain'
                }
              },
              {
                path: 'partsData.masterPartsDataCNCId',
                select: '_id',
              },
              {
                path: 'partsData.cncMaterial',
                select: '_id cnc_material cnc_grade'
              },
              {
                path: 'partsData.cncTolerance',
                select: '_id cnc_tolerance'
              },
              {
                path: 'partsData.cncPartMarking',
                select: '_id cnc_part_marking'
              },
              {
                path: 'partsData.cncReviewMyDesign',
                select: '_id cnc_review_my_design'
              },
              {
                path: 'partsData.cncSurfaceFinish',
                select: '_id cnc_surface_finish'
              },
              {
                path: 'partsData.cncHeatTreatment',
                select: '_id cnc_heat_treatment'
              },
              {
                path: 'partsData.cncInternalCorner',
                select: '_id cnc_internal_corner'
              },
              {
                path: 'partsData.stagingPartsDataId',
                select: '_id'
              },
              {
                path: 'userId',
                select: "firstName lastName _id email companySiteId",
                populate: {
                  path: 'companySiteId',
                  select: 'companyName tax domain',
                }
              }
            ]
          }
        ], 'getdata quote data for cnc ');
        selectedQuoteDetails.data.data = res?.results?.quotes[0];
      }
      else if (selectedProcess == 2) {
        const res = await getData([
          {
            modelName: 'quotes',
            fields: [],
            "filter": { "_id": (id || _id) },
            "populate": [
              {
                path: 'followers',
                select: '_id firstName lastName email companySiteId userCompanySite',
                populate: {
                  path: 'companySiteId',
                  select: '_id domain'
                }
              },
              {
                path: 'partsData.masterPartsDataThreeDId',
                select: '_id',
              },
              {
                path: 'partsData.threeDTechnology',
                select: 'name'
              },
              {
                path: 'partsData.threeDMachine',
                select: 'name'
              },
              {
                path: 'partsData.threeDMaterial',
                select: 'name'
              },
              {
                path: 'partsData.threeDPostProcessing',
                select: 'name'
              },
              {
                path: 'partsData.stagingPartsDataId',
                select: '_id'
              },
              {
                path: 'userId',
                select: "firstName lastName _id email companySiteId",
                populate: {
                  path: 'companySiteId',
                  select: 'companyName tax domain',
                }
              }
            ]
          }
        ], 'getdata quote data for threeD ');
        selectedQuoteDetails.data.data = res?.results?.quotes[0];
      }
      else {
        const res = await getData([
          {
            modelName: 'quotes',
            fields: [''],
            "filter": { "_id": (id || _id) },
            "populate": [
              {
                path: 'followers',
                select: '_id firstName lastName email companySiteId userCompanySite',
                populate: {
                  path: 'companySiteId',
                  select: '_id domain'
                }
              },
              {
                path: 'partsData.stagingPartsDataId',
                select: '_id'
              },
              {
                path: 'userId',
                select: "firstName lastName _id email companySiteId",
                populate: {
                  path: 'companySiteId',
                  select: 'companyName tax domain',
                }
              }
            ]
          }
        ], 'getdata quote data for manual process ');
        selectedQuoteDetails.data.data = res?.results?.quotes[0];
      }
      return selectedQuoteDetails;

    } catch (error) {
      throw new Error("Failed to fetch data");

    }

  }

  const fetchAllQoutesForRefId = async () => {
    try {
      setIsLoading(true);

      const selectedQuoteDetails = await fetchDataForSelectedQuote();
      const quote = selectedQuoteDetails.data.data;


      setSelectedQuote({
        ...quote,
        shippingCharge3: quote?.shippingCharge3?.toFixed(2),
        shippingCharge2: quote?.shippingCharge2?.toFixed(2),
        shippingCharge1: quote?.shippingCharge1?.toFixed(2),
      });
      setIsLoading(false);
      setIsDfmDataLoading(true);
      setIsSecondaryLoading(true);
      const ids = quote?.partsData.map((part) => part?.stagingPartsDataId?._id);
      const res = await getDFMInfo(ids);
      const dfmData = res?.data;
      const partsData = quote?.partsData;
      const updatedPartsData = partsData.map((part) => {
        const stagingPartsDataId = part?.stagingPartsDataId?._id;
        if (stagingPartsDataId && dfmData[stagingPartsDataId]) {
          return {
            ...part,
            ...(dfmData[stagingPartsDataId]?.data || {}),
          };
        }
        return part;
      });
      setSelectedQuote((pre) => ({
        ...pre,
        partsData: updatedPartsData,
      }));
      setIsDfmDataLoading(false);
      setLeadTime([quote.leadTime1, quote.leadTime2, quote.leadTime3]);
      setShippingDays([quote.shippingDays1, quote.shippingDays2, quote.shippingDays3]);
      setEditableProjectName(quote.projectName);
      if (quoteRefId != quote.RefId) {

        setQuoteRefId(quote.RefId);
        const allVersionsRes = await fetchQuoteByRefId(quote.RefId, token);

        const allVersions = allVersionsRes.data.data;
        setAllVersionForRefId(allVersions);

        const quoteIds = allVersions.map(v => v._id);
        const ordersRes = await getSalesOrdersForAllQuotation(token, quoteIds);

        if (ordersRes.status) {
          setAllOrdersForProject(ordersRes.data);

          const filteredOrder = ordersRes.data.find(
            (item) => item.quoteId._id === quote._id
          );
          if (filteredOrder) {
            setSalesOrder(filteredOrder);
          }
        }

      }



    } catch (err) {
    } finally {
      setIsSecondaryLoading(false);
      setIsLoading(false);
      setIsDfmDataLoading(false);
    }
  };



  const validateData = async () => {
    const errors = [];

    const optionLabels = {
      1: 'Rapid',
      2: 'Standard',
      3: 'Economy'
    };

    // Check if linesTotal are all falsy
    if (!linesTotal[0] && !linesTotal[1] && !linesTotal[2]) {
      errors.push("At least one line total is required.");
    }

    // Validate quantity in partsData
    selectedQuote?.partsData?.forEach((part, index) => {
      if (!part?.Qty || isNaN(part?.Qty)) {
        errors.push(`Missing or invalid 'Qty' at row ${index + 1}`);
      }
    });

    // Validate price, lead time, and shipping days
    for (let i = 0; i < 3; i++) {
      const optionIndex = i + 1;
      const label = optionLabels[optionIndex];

      const priceKey = `price${optionIndex}`;
      const leadTimeKey = `leadTime${optionIndex}`;
      const shippingDaysKey = `shippingDays${optionIndex}`;

      if (parseFloat(selectedQuote[priceKey]) > 0) {
        if (Number(selectedQuote[leadTimeKey]) <= 0 || isNaN(Number(selectedQuote[leadTimeKey]))) {
          errors.push(`Missing or invalid 'lead time' for ${label} option`);
        }
        // if (Number(selectedQuote[shippingDaysKey]) <= 0 || isNaN(Number(selectedQuote[shippingDaysKey]))) {
        //   errors.push(`Missing or invalid 'shipping days' for ${label} option`);
        // }
      }
    }

    // Validate shipping charges
    // for (let i = 1; i <= 3; i++) {
    //   const label = optionLabels[i];
    //   if (selectedQuote[`price${i}`] && !(selectedQuote[`shippingCharge${i}`] > 0)) {
    //     errors.push(`Missing or zero 'shipping charge' for ${label} option`);
    //   }
    // }

    // Show error modal if any errors found
    if (errors.length > 0) {
      await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Validation failed',
          content: (
            <ul style={{ color: 'red' }}>
              {errors.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          ),
          okText: 'OK',
          cancelButtonProps: { style: { display: 'none' } },
          onOk: () => resolve(),
        });
      });
      return false;
    }

    return true;
  };




  const validationForSendEmailPdf = (functionality) => {

    let selectedShipMethodsToSendEmail = [];
    if (selectedQuote.price1) {
      selectedShipMethodsToSendEmail.push(1);
    }
    if (selectedQuote.price2) {
      selectedShipMethodsToSendEmail.push(2);
    }

    if (selectedQuote.price3) {
      selectedShipMethodsToSendEmail.push(3);
    }
    if (selectedShipMethodsToSendEmail.length == 0) {
      toast.error("Please update the prices before sending the quote.");
      return false;
    }
    setFunctionalityForDQ(functionality);
    if (functionality == "download-quote") {
      if (selectedShipMethod === "") {
        toast.error("Select a cost for which you want to download the quote.");
        return false;
      }
    }
    if (
      isChanged.partInfo ||
      isChanged.leadtime ||
      isChanged.shippingCharge ||
      isChanged.shippingDays
    ) {
      toast.error(
        "There are some unsaved changes. Please update order before sending the quotation to customer email."
      );
      return false;
    }

    return true;
  }



  const handleSendEmail = async () => {
    try {
      if (!addressValues.shippingAddress && !isNoShippingAddressSelected) {
        setDownloadQuoteModalError(
          "Please select a valid shipping address to download quotation."
        );
        return;
      }
      if (!addressValues.billingAddress && !isNoBillingAddressSelected) {
        setDownloadQuoteModalError(
          "Please select a valid billing address to download quotation."
        );
        return;
      }
      let adminResponse = false;
      if (selectedQuote.isEmailSent) {
        adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Resend quotation email?',
            content: 'Quotation email is already sent to customer for this quote. Are you sure you want to send the email again?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
      } else {


        adminResponse = adminResponse = await new Promise((resolve) => {
          AntModal.confirm({
            title: 'Confirm',
            content: 'Are you sure you want to send the quotation details to user email?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        });
      }
      if (!adminResponse) return;
      setIsLoaderActive(true);
      setShowDQModal(false);
      const shippingAddressId = addressValues.shippingAddress;
      const billingAddressId = addressValues.billingAddress;

      let data = {
        fname: selectedQuote?.userId.firstName,
        email: selectedQuote?.userId.email,
        quoteRefId: selectedQuote?.RefId,
        quoteId: selectedQuote._id,
        price1: selectedQuote?.price1 || 0,
        price3: selectedQuote.price3 || 0,
        price2: selectedQuote?.price2 || 0,
        hidePrice: selectedQuote?.hidePrice,
        partsLength: selectedQuote?.partsData.length,
        process: selectedQuote?.selectedProcess,
        partData: selectedQuote?.partsData,
        shippingAddressId,
        billingAddressId,
      };
      let response = await sendQuotationToCustomerEmail(token, data);
      if (response.status == false) {
        setIsLoaderActive(false);
        toast.error("Something went wrong while sending email to customer.");
        return;
      } else {
        toast.success("Quotation sent to email successfully.");
        setIsLoaderActive(false);
        let localAllVersionForRefId = [...allVersionForRefId];
        localAllVersionForRefId.forEach((item) => {
          if (item._id == selectedQuote._id) {
            item.isEmailSent = true;
            item.quoteStatus = response?.data?.payload?.quotationStatus;
          }
        });
        setAllVersionForRefId(localAllVersionForRefId);
        setSelectedQuote({ ...selectedQuote, isEmailSent: true, isSent: true, });
      }
    } catch (err) {
      setIsLoaderActive(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const handleQuoteSend = ErrorCheckHOF(async () => {
    try {
      if (
        isChanged.partInfo ||
        isChanged.shippingCharge ||
        isChanged.leadtime ||
        isChanged.shippingDays
      ) {
        toast.error(
          "Please update the quotation "
        );
        return;
      }

      let shipMethodWithPrice = [];
      if (selectedQuote.price1) {
        shipMethodWithPrice.push(1);
      }
      if (selectedQuote.price2) {
        shipMethodWithPrice.push(2);
      }

      if (selectedQuote.price3) {
        shipMethodWithPrice.push(3);
      }

      if (shipMethodWithPrice.length == 0) {
        toast.error("At least one cost (Rapid, Standard, or Economy) is required.");
        return;
      }



      let data = {
        quoteId: selectedQuote._id,
      };

      let response = await handleMarkAsSend(token, data);
      let localAllVersionForRefId = [...allVersionForRefId];
      localAllVersionForRefId.forEach((item) => {
        if (item._id == response?.data?._id) {
          item.isSent = response?.data?.isSent;
          item.quoteStatus = response?.data?.quotationStatus;
        }
      });
      setAllVersionForRefId(localAllVersionForRefId);
      setSelectedQuote({ ...selectedQuote, isSent: response?.data?.isSent });
      toast.success("The quotation is now marked as 'Sent'");
    } catch (err) {
      console.error("error", err);
    }
  });

  const handleUndefinedNumber = (value) => Number.isNaN(value) || value === undefined || value === null || value == '' ? 0 : value;

  const handleUpdateQuote = async (updateOption) => {
    try {
      if (!versionDescriptionValue) {
        toast.error("Please select the value for  version description");
        return;
      }

      setShowModal(false);
      let adminUserResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Confirm',
          content: 'Are you sure you want to update the quotation?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (adminUserResponse) {
        setIsLoading(true);
        setShowModal(false);
        let data = {
          partsData: selectedQuote?.partsData,
          _id: selectedQuote?._id,
          process: selectedQuote?.selectedProcess,
          leadTime: leadTime,
          price1: selectedQuote.price1 || linesTotal[0],
          price2: selectedQuote.price2 || linesTotal[1],
          price3: selectedQuote.price3 || linesTotal[2],
          updateOption: updateOption,
          shippingCharge1: handleUndefinedNumber(selectedQuote.shippingCharge1),
          shippingCharge2: handleUndefinedNumber(selectedQuote.shippingCharge2),
          shippingCharge3: handleUndefinedNumber(selectedQuote.shippingCharge3),
          shippingDays1: handleUndefinedNumber(selectedQuote.shippingDays1),
          shippingDays2: handleUndefinedNumber(selectedQuote.shippingDays2),
          shippingDays3: handleUndefinedNumber(selectedQuote.shippingDays3),
          adminComment: selectedQuote?.adminComment,
          versionDescription: versionDescriptionValue,
          isTargetCostUpdatedByAdmin: isCostUpdatedbyAdminWhenTargetCostIsAvailable,
          certifications: selectedQuote?.certifications,
          orderCertificationsCost: selectedQuote?.orderCertificationsCost,
          quotationNotes: selectedQuote?.quotationNotes,
        };

        let response = await updateQuoteAdmin(data, token);
        let updatedQuote = (await fetchDataForSelectedQuote(response?.data?.id)).data.data;

        if (response?.status == false) {
          throw {
            message: "Something went wrong while updating price!",
          };
        } else {
          toast.success("Price update successfully");
          setSelectedQuote(updatedQuote);
          if (updateOption == "new") {
            let localAllQuoteVersion = [...allVersionForRefId, updatedQuote];
            localAllQuoteVersion.sort((a, b) => {
              return b.version - a.version;
            });
            setAllVersionForRefId(localAllQuoteVersion);
          } else {
            let localAllQuoteVersion = [...allVersionForRefId];
            localAllQuoteVersion.forEach((item, index) => {
              if (item?._id === updatedQuote?._id) {
                localAllQuoteVersion[index] = updatedQuote;
              }
            });

            localAllQuoteVersion.sort((a, b) => {
              return b.version - a.version;
            });


            setAllVersionForRefId([...localAllQuoteVersion]);
          }
          if (updateOption == "new") {
            navigate(`/admin/admin-quote/${updatedQuote?._id}`);
          }
          setIsLoading(false);
          fetchSupplierDataForQuoteId(updatedQuote?._id);
          setIsChanged({
            ...isChanged,
            partInfo: false,
            leadtime: false,
            shippingCharge: false,
            shippingDays: false,
            certifications: false,
          });
        }

      }
    } catch (err) {
      console.error("err", err);
      let message =
        err && err.message
          ? err.message
          : "Something went wrong during fetch getSaveQuoteData";
      return false;
    } finally {
      setIsLoading(false);
      setIsAnyUnsavedChanges(false);
    }
  };

  const handleLeadTimeChange = (event, index) => {
    const value = event.target.value;
    const isEmpty = value === "";
    const isNaturalNumber = /^[1-9][0-9]*$/.test(value);
    if (!isEmpty && !isNaturalNumber) {
      return;
    }
    setIsChanged({ ...isChanged, leadtime: true });
    let localLeadTimeCopy = [...leadTime];
    let leadTimeAtIndex = { ...leadTime[index] };
    leadTimeAtIndex = event.target.value;
    localLeadTimeCopy[index] = leadTimeAtIndex;
    setLeadTime(localLeadTimeCopy);
    setSelectedQuote({
      ...selectedQuote,
      leadTime1: localLeadTimeCopy[0],
      leadTime2: localLeadTimeCopy[1],
      leadTime3: localLeadTimeCopy[2],
    });
  };

  const handleCertificationCostChange = (value) => {
    setSelectedQuote((pre) => {
      return { ...pre, orderCertificationsCost: trimToTwoDecimals(value) }
    })

  }


  const handleShippingLeadTimeChange = (event, index) => {
    const value = event.target.value;
    // const isEmpty = value === "";
    // const isNaturalNumber = /^[1-9][0-9]*$/.test(value);
    // if (!isEmpty && !isNaturalNumber) {
    //   return;
    // }
    setIsChanged({ ...isChanged, shippingDays: true });
    let localShippingLeadTimeCopy = [...shippingDays];
    let shippingLeadTimeAtIndex = { ...shippingDays[index] };
    shippingLeadTimeAtIndex = event.target.value;
    localShippingLeadTimeCopy[index] = shippingLeadTimeAtIndex;
    setShippingDays(localShippingLeadTimeCopy);
    setSelectedQuote({
      ...selectedQuote,
      shippingDays1: localShippingLeadTimeCopy[0],
      shippingDays2: localShippingLeadTimeCopy[1],
      shippingDays3: localShippingLeadTimeCopy[2],
    });
  };


  const handleQMShowClick = (functionality) => {
    const isValid = validationForSendEmailPdf(functionality);
    if (!isValid) return;


    setShowDQModal(true);
  };

  const handleMoveOutFromUnloggedStage = async () => {
    try {
      const response = await changeLoggedStatus(_id, { isLogged: true });
      if (!response || !response.success) {
        throw new Error("Failed To change Status ");
      }
      setSelectedQuote((pre) => {
        return { ...pre, isLogged: true }
      });

    } catch (error) {
      console.error(error);
    }
  }
  const handleMoveToUnloggedState = async () => {
    try {
      const response = await changeLoggedStatus(_id, { isLogged: false });
      if (!response || !response.success) {
        throw new Error("Failed To change Status ");
      }
      setSelectedQuote((pre) => {
        return { ...pre, isLogged: false }
      });

    } catch (error) {
      console.error(error);
    }
  }

  let handleDownload = async () => {
    setDownloadQuoteModalError();
    try {
      if (!addressValues.shippingAddress && !isNoShippingAddressSelected) {
        setDownloadQuoteModalError(
          "Please select a valid shipping address to download quotation."
        );
        return;
      }
      if (!addressValues.billingAddress && !isNoBillingAddressSelected) {
        setDownloadQuoteModalError(
          "Please select a valid billing address to download quotation."
        );
        return;
      }

      let data = {
        type: 'url',
        quoteId: selectedQuote?._id,
        selectedShipMethod,
        shippingAddress: isNoShippingAddressSelected ? "" : addressValues.shippingAddress,
        billingAddress: isNoBillingAddressSelected ? "" : addressValues?.billingAddress,
        RefId: selectedQuote?.RefId,
        // version: selectedQuote?.Version,
        price: selectedShipMethod == 1 ? selectedQuote?.price1 + selectedQuote?.shippingCharge1 + selectedQuote?.orderCertificationsCost
          : selectedShipMethod == 2 ? selectedQuote?.price2 + selectedQuote?.shippingCharge2 + selectedQuote?.orderCertificationsCost : selectedQuote?.price3 + selectedQuote?.shippingCharge3 + selectedQuote?.orderCertificationsCost
      };

      let lastDataOnPdf = selectedShipMethod == 1 ? "Rapid" : (
        selectedShipMethod == 2 ? "Standard" : "Economy"
      );
      setShowDQModal(false);
      setQuotationDownloading(true);

      let response = await downloadQuotationPdf(data);

      const { signedUrl } = response.data;

      const fileName = `${replaceSpacesWithUnderscore(organizationName)}_Quote_${selectedQuote?.RefId}_V${selectedQuote.version}_${lastDataOnPdf}.pdf`;
      setPdfModalInfo({
        show: true,
        fileName,
        pdfUrl: signedUrl,
      })
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);


    } catch (err) {
      setDownloadQuoteModalError("Error downloading Quotation", err)
    } finally {
      setQuotationDownloading(false);
    }
  };

  const handleBack = async () => {
    let adminResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Confirm Navigation',
        content: 'Information will be lost, are you sure you want to go back?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (adminResponse) {
      navigate(-1);
    }
  };

  useEffect(() => {
    handleChangeQuoteVersion(_id);
  }, [_id]);

  const handleChangeQuoteVersion = (selectedQuoteId) => {
    allVersionForRefId.forEach((quote) => {
      if (quote._id == selectedQuoteId) {
        setSelectedQuote(quote);
        let localLeadTime = [quote.leadTime1, quote.leadTime2, quote.leadTime3];
        setLeadTime(localLeadTime);
        fetchSupplierDataForQuoteId(quote._id);
        let line1Total = 0,
          line2Total = 0,
          line3Total = 0;
        quote?.partsData?.forEach((item) => {
          line1Total += Number(item.Qty || 0) * parseFloat(item.price1 || 0);
          line2Total += Number(item.Qty || 0) * parseFloat(item.price2 || 0);
          line3Total += Number(item.Qty || 0) * parseFloat(item.price3 || 0);
        });
        setLinesTotal([line1Total, line2Total, line3Total]);


        let filteredOrders = allOrdersForProject.filter(
          (item) => item.quoteId._id == quote._id
        );
        if (filteredOrders.length) {
          setSalesOrder(filteredOrders[0]);
        } else {
          setSalesOrder(null);
        }
      }
    });
  };

  const fetchSupplierDataForQuoteId = async (quoteId) => {
    try {
      const fetchRFQResponse = await fetchRFQForQuotation(quoteId, token);
      if (fetchRFQResponse.data.status) {
        setRFQForQuotation(fetchRFQResponse.data.data);
      } else {
        setRFQForQuotation(null);
      }
    } catch (err) {
      console.error(
        "err in admin quote 682 on" +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleQuotePriceSelection = (e) => {
    userSelectCostRef.current = true;
    setSelectedShipMethod(Number(e.target.value));
    setSelectedQuote({ ...selectedQuote, selectedShipMethod: e.target.value });
  };

  const handleEditQuote = ErrorCheckHOF(() => {
    navigate(`/create-instant-quotation/${selectedQuote?._id}`, { state: { isComingFromQuoteAdmin: true } });
  });

  const handleMoveToProgress = async () => {
    try {
      let data = {
        quoteId: selectedQuote._id,
      };
      const response = await moveQuoteToProgressStatus(token, data);
      if (response.status) {
        setSelectedQuote({
          ...selectedQuote,
          isCancelled: false,
        });

        let localAllVersionForRefId = [...allVersionForRefId];
        localAllVersionForRefId.forEach((item) => {
          if (item._id == selectedQuote._id) {
            item.isCancelled = false;
          }
        });
        setAllVersionForRefId(localAllVersionForRefId);

        toast.success(response.message);
      } else {
        toast.error("Something went wrong.Please try again later!");
      }
    } catch (e) {
      toast.error(e.message || "Something went wrong.Please try again later!");
    }
  };

  const handleCancelQuoteClick = async () => {
    try {
      if (selectedQuote.isCancelled) {
        toast.error("Quotation is already cancelled");
        return;
      }

      if (selectedQuote?.myorders) {
        toast.error("Sales order for this quotation is already created.");
        return;
      }
      const quoteCancelResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Cancel Quotation Version?',
          content: 'Are you sure that you want to cancel this version of quotation?',
          okText: 'Yes',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });

      if (quoteCancelResponse) {
        let data = {
          quoteId: selectedQuote._id,
        };
        const response = await handleQuoteCancel(token, data);
        if (response.status) {
          const adminResponse = await new Promise((resolve) => {
            AntModal.confirm({
              title: 'Cancel RFQ?',
              content: 'Do you want to cancel the RFQ associated with the quotation?',
              okText: 'Yes',
              cancelText: 'No',
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            });
          });
          if (adminResponse) {
            let quotationIdsForRFQ = [selectedQuote._id];
            await cancelRFQForQuotation(token, {
              quoteIds: quotationIdsForRFQ,
            });
          }
          setSelectedQuote({
            ...selectedQuote,
            isCancelled: true,
          });

          let localAllVersionForRefId = [...allVersionForRefId];
          localAllVersionForRefId.forEach((item) => {
            if (item._id == selectedQuote._id) {
              item.isCancelled = true;
            }
          });
          setAllVersionForRefId(localAllVersionForRefId);

          toast.success(response.message);
        } else {
          toast.error("Something went wrong.Please try again later!");
        }
      } else {
        return;
      }
    } catch (err) {
      console.error("error", err);
      toast.error("Something went wrong.Please try again later");
    }
  };

  const handleProceedToPO = async () => {
    setPoModalErrors("");
    if (!poNumber || !poDocument) {
      setPoModalErrors("Po Number and Po document are required to create an order.");
      return;
    }
    setShowSoModal(false);
    setShowDQModal(false);


    let userResponse = await new Promise((resolve) => {
      AntModal.confirm({
        title: 'Proceed with Selected Version?',
        content: 'Are you sure you want to proceed with the selected version?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (userResponse) {
      setShowSoModal(true);
      setIsPoLoaderActivated(true);
      try {
        let data = {
          quoteId: selectedQuote?._id,
          selectedShipMethod: selectedShipMethod,
        };
        await updateQuoteShipMethod(token, data);

        let shippingCharge = 0;
        if (selectedShipMethod == 1) {
          shippingCharge = selectedQuote?.shippingCharge1;
        }
        else if (selectedShipMethod == 2) {
          shippingCharge = selectedQuote?.shippingCharge2;
        }
        else if (selectedShipMethod == 3) {
          shippingCharge = selectedQuote?.shippingCharge3;
        }

        let formData = new FormData();
        formData.append("shippingAddress", addressValues?.address[0]._id);
        formData.append("billingAddress", billingAddressForUser[0]?._id);
        formData.append("tax", (selectedQuote?.userId?.companySiteId?.taxes || 0));
        formData.append(
          "subTotal",
          selectedShipMethod === 1
            ? selectedQuote?.price1
            : selectedShipMethod === 2
              ? selectedQuote?.price2
              : selectedQuote?.price3
        );
        formData.append("quoteSelectedShipMethod", selectedShipMethod);
        formData.append("quoteId", selectedQuote?._id);
        formData.append("file", poDocument);
        formData.append("purchaseNumber", poNumber);
        formData.append("orderNumberLater", false);
        formData.append("certifications", handleUndefinedNumber(selectedQuote?.orderCertificationsCost));
        formData.append("shipping", handleUndefinedNumber(shippingCharge));


        const res = await newCheckout(formData, token);

        if (res.response?.data?.data?.message) {
          toast.error(res.response.data.data.message);
          return;
        }

        if (res.data.status === false) {
          toast.error("Something went wrong while placing the order");
          return;
        }

        navigate("/admin/orders/" + res.data.data._id, {
          state: { order: res.data.data },
        });

      } catch (err) {
        console.error("err", err);
        return err;
      } finally {
        setIsPoLoaderActivated(false);
      }
    }
  };


  const handleShippingChargeChange = (e, index) => {






    setIsChanged({ ...isChanged, shippingCharge: true });
    let shippingChargeValue = trimToTwoDecimals(e.target.value);
    let totalPrice1 = 0;
    let totalPrice2 = 0;
    let totalPrice3 = 0;
    selectedQuote?.partsData.map((item, i) => {
      totalPrice1 += Number(item.price1) * Number(item.Qty);
      totalPrice2 += Number(item.price2) * Number(item.Qty);
      totalPrice3 += Number(item.price3) * Number(item.Qty);
      return;
    });

    if (index == 1) {
      setSelectedQuote({
        ...selectedQuote,
        shippingCharge1: shippingChargeValue,
        price1: totalPrice1,
      });
    } else if (index == 2) {
      setSelectedQuote({
        ...selectedQuote,
        shippingCharge2: shippingChargeValue,
        price2: totalPrice2,
      });
    } else {
      setSelectedQuote({
        ...selectedQuote,
        shippingCharge3: shippingChargeValue,
        price3: totalPrice3,
      });
    }
  };

  const handleUpdateAdminComment = async () => {
    try {
      let data = {
        RefId: selectedQuote.RefId,
        adminComment: selectedQuote.adminComment,
      };
      const response = await updateQuoteAdminComment(data);
      if (response.status) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(
        "err in admin quote 921 on" +
        moment(Date.now()).format("DD MMM YYYY hh:mm:ss a"),
        err
      );
    }
  };

  const handleProceedToSOModal = ErrorCheckHOF(() => {
    if (
      isChanged.partInfo ||
      isChanged.shippingCharge ||
      isChanged.leadtime ||
      isChanged.shippingDays
    ) {
      toast.error("Please update the quotation before downloading the quote.");
      return;
    }

    if (selectedShipMethod === "") {
      toast.error("Select the cost for which you want to place an order.");
      return;
    }
    if (
      ((selectedShipMethod == 1 && selectedQuote?.price1 == 0) ||
        (selectedShipMethod == 2 && selectedQuote?.price2 == 0) ||
        (selectedShipMethod == 3 && selectedQuote?.price3 == 0))
    ) {
      toast.error("Invalid selection of price.");
      return;
    }


    setShowDQModal(true);
    setFunctionalityForDQ('proceed-po');
    // setShowSoModal(true);
  });

  const handleCreateRFQ = async (type) => {
    try {
      if (
        isChanged.partInfo ||
        isChanged.additionalCost ||
        isChanged.shippingCharge ||
        isChanged.leadtime ||
        isChanged.shippingDays
      ) {
        toast.error(
          "Please update the quotation before downloading the quote."
        );
        return;
      }

      let partsData = [];
      const parts = selectedQuote.projectName.split("_");
      let projectName = parts.slice(1).join("_");
      projectName = prompt(
        "Enter the project name for selected supplier.",
        projectName
      );
      if (projectName?.length > 0) {
        setIsLoading(true);
        setShowSendtoSupplierModal(false);
        selectedQuote.partsData.forEach((item) => {
          let partDataAtIndex = {
            cncMaterial: item.cncMaterial?._id,
            cncSurfaceFinish: item.cncSurfaceFinish?._id,
            cncHeatTreatment: item.cncHeatTreatment?._id,
            cncTolerance: item.cncTolerance?._id,
            cncPartMarking: item.cncPartMarking?._id,
            cncReviewMyDesign: item?.cncReviewMyDesign?._id,
            cncInternalCorner: item?.cncInternalCorner?._id,
            threeDTechnology: item.threeDTechnology?._id,
            threeDMachine: item.threeDMachine?._id,
            threeDMaterial: item.threeDMaterial?._id,
            threeDPostProcessing: item.threeDPostProcessing?._id,
            qty: item.Qty,
            partNotes: item.Notes,
            description: item.description,
            stagingPartsDataId: item?.stagingPartsDataId?._id,
            selectedFile: item.selectedFile,
            twoDFile: item.twoDFile,
            gltfPlainFileUrl: item.gltfPlainFileUrl,
            thumbnail: item?.thumbnail,
            partName: "",
            makePartDataId: item?._id,
          };
          partsData.push(partDataAtIndex);
        });
        var projectNames;
        if (type == "offer") {
          projectNames = `O_${selectedQuote.RefId}-V-${selectedQuote.version}-${projectName}`;
        } else {
          projectNames = `${selectedQuote.RefId}-V-${selectedQuote.version}-${projectName}`;
        }
        let data = {
          type: type,
          quotationId: selectedQuote._id,
          quotationRefId: `${selectedQuote.RefId}-V-${selectedQuote.version}`,
          selectedProcess: selectedQuote.selectedProcess,
          isQrTrackingRequested: selectedQuote.isQrTrackingRequested,
          isDimensionalReportRequested:
            selectedQuote.isDimensionalReportRequested,
          isConformanceCertificateRequested:
            selectedQuote.isConformanceCertificateRequested,
          partsData,
          rfqOfferStatus: "active",
          projectName: projectNames,
        };

        let rFQResponse = await createRFQ(data, token);
        if (rFQResponse.data.status) {
          toast.success(rFQResponse.data.message);
          if (type == "offer") {
            navigate(`/admin/offers-details/${rFQResponse.data.data._id}`);
          } else {
            navigate(`/admin/rfq-details/${rFQResponse.data.data._id}`);
          }

        } else {
          toast.error(rFQResponse.data.message);
          return;
        }
      } else {
        toast.error("Enter valid project name");
        return;
      }
    } catch (err) { setIsLoading(false); }
    finally {
      setIsLoading(false);
    }
  };

  const handleGoToRFQClick = (type, id) => {
    if (type == 'offer') {
      navigate(`/admin/offers-details/${id}`);
    }
    if (type == 'rfq') {
      navigate(`/admin/rfq-details/${id}`);
    }

  };

  const handleUpdateButtonClick = async () => {
    if (selectedQuote.isCancelled) {
      toast.error("Quote is already cancelled.");
      return;
    }


    let isDataValid = await validateData();
    if (!isDataValid) {
      return;
    }
    setShowModal(true);
  };

  const handleVersionDescriptionSelect = (e) => {
    setVersionDescriptionValue(e.target.value);
  };

  const handleItemInformationChange = (index, field, value) => {
    setIsAnyUnsavedChanges(true);
    if (field === "Qty") {
      const isEmpty = value === "";
      const isNaturalNumber = /^[1-9][0-9]*$/.test(value);
      if (!isEmpty && !isNaturalNumber) {
        return;
      }
    }
    try {
      let localPartsData = [...selectedQuote?.partsData];
      setIsChanged({ ...isChanged, partInfo: true });
      //check if pricing is updated or not
      if (['price1', 'price2', 'price3'].includes(field)) {
        //
        localPartsData[index][field] = trimToTwoDecimals(value);
        userSelectCostRef.current = false
      }
      else {
        localPartsData[index][field] = value;
      }

      let totalPrice1 = 0;
      let totalPrice2 = 0;
      let totalPrice3 = 0;

      if (
        field == "price1" ||
        field == "price2" ||
        field == "price3" ||
        field == "Qty"
      ) {
        if ((field == 'price1' || field == 'price2' || field == 'price3') && selectedQuote?.userTargetCost) {
          setIsCostUpdatedByAdminWhenTargetCostIsAvailable(true);


        };
        localPartsData.forEach((item, i) => {
          totalPrice1 += Number(item.price1) * Number(item.Qty);
          totalPrice2 += Number(item.price2) * Number(item.Qty);
          totalPrice3 += Number(item.price3) * Number(item.Qty);
        });
      }

      setSelectedQuote({
        ...selectedQuote,
        partsData: localPartsData,
        price1: totalPrice1,
        price2: totalPrice2,
        price3: totalPrice3,
      });
    } catch (err) {
      console.error("Error", err);
    }
  };

  const renderProjectName = () => {
    try {
      const firstUnderscoreIndex = selectedQuote?.projectName?.indexOf("_");
      const serialNumber = selectedQuote?.projectName.substring(
        0,
        firstUnderscoreIndex
      );
      const editableText = selectedQuote?.projectName.substring(
        firstUnderscoreIndex + 1
      );

      if (isEditingProjectName) {
        return (
          <>
            <div className="flex items-center justify-center  text-sm ">
              <span className="w-full">{selectedQuote?.RefId}_</span>
              <Form.Control
                type="text"
                value={editableProjectName}
                onChange={(e) => setEditableProjectName(e.target.value)}
                style={{
                  margin: " 0px 4px",
                  height: "25px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              />
              <span onClick={() => handleUpdateClick()}>
                <EditIcon additionalClass={"!h-4 ms-2 text-primaryColor"} />
              </span>

              <span onClick={() => handleCancelClick()}>
                <CrossIcon additionalClass={"!h-4 ms-2 text-primaryColor"} />
              </span>
            </div>
          </>
        );
      }

      return (
        <div className="flex items-center">
          <Link to={``}>
            <span>
              {selectedQuote?.projectName?.length >= 25
                ? selectedQuote?.projectName?.slice(0, 10) + "..."
                : selectedQuote?.projectName}
            </span>
          </Link>

          <span onClick={() => handleEditClick()}>
            <EditIcon additionalClass={"!h-4 ms-2 text-primaryColor"} />
          </span>
        </div>
      );
    } catch (err) {
      console.error("Error", err);
    }
  };

  const handleSelectCertification = (cert) => {
    const { _id, certificationType, price } = cert;

    //check is certPresent Or Not 
    const orderCertificationsCost = selectedQuote?.orderCertificationsCost;
    let costToAdjust = (() => {
      if (certificationType == 'per order') {
        return price;
      }
      else if (certificationType == 'per line item') {
        return selectedQuote?.partsData?.length * price;
      }
      return 0;
    })();
    const isCertificationAlReadyExists = selectedQuote?.certifications?.find((item) => item?._id == _id);
    let updatedCertifications;
    let updatedOrderCertificationsCost;

    if (isCertificationAlReadyExists) {
      updatedCertifications = selectedQuote?.certifications.filter((item) => item?._id != _id);
      updatedOrderCertificationsCost = orderCertificationsCost - costToAdjust;
    }
    else {
      updatedCertifications = [...selectedQuote?.certifications, cert];
      updatedOrderCertificationsCost = orderCertificationsCost + costToAdjust;
    }

    setSelectedQuote((pre) => {
      return {
        ...pre,
        certifications: updatedCertifications,
        orderCertificationsCost: updatedOrderCertificationsCost,
      }
    });
    setIsChanged((pre) => {
      return { ...pre, certifications: true };
    });

  };


  const handleMaterialMasterChange = (event, key, index) => {
    setSelectedQuote((pre) => {
      const partsData = pre.partsData;
      partsData[index][key] = event.target.value;
      return { ...pre, partsData };
    })

  }
  const moveLineItemToXindex = (index, direction) => {



    const values = selectedQuote?.partsData;
    const tempValue = JSON.parse(JSON.stringify(values[index + direction]))

    values[index + direction] = values[index];
    values[index] = tempValue;
    setSelectedQuote((pre) => {
      return {
        ...pre,
        partsData: values,
      }
    })
  }


  return (
    <div className="admin-container">
      {/* {isLoading ? (
        <>
          <Loading />
        </>
      ) : (
        ""
      )} */}
      <GenericLoaderComponent
        isLoading={isLoading}
      />

      <CaptchaModal
        showModal={showCaptchaModal}
        handleClose={handleCloseCaptchaModal}
        handleSendEmail={handleSendEmail}
        buttonText="Send Email"
      />
      <EditProjectName
        key={selectedQuote?.projectName}
        show={showProjectNameModal}
        currentName={selectedQuote?.projectName}
        onSave={handleUpdateClick}
        onCancel={() => setShowProjectNameModal(false)}
      />
      <CaptchaModal
        showModal={isCaptchaModalForAskTargetCost}
        handleClose={() => setIsCaptchModalForAskTargetCost(false)}
        handleSendEmail={handleTargetCostAsk}
        buttonText="Ask Target Cost"
      />
      <PDFModalViewer
        show={pdfModalInfo.show}
        pdfUrl={pdfModalInfo.pdfUrl}
        fileName={pdfModalInfo.fileName}
        handleClose={() => {
          setPdfModalInfo({
            show: false,
            fileName: '',
            pdfUrl: "",
          })
        }}
      />
      {showAddressModal && (
        <AddressModal
          addressModal={showAddressModal}
          setShowAddressModal={setShowAddressModal}
          recentAddress={addressValues?.address}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          id={editId}
          values={addressValues}
          handledAddAddress={handledAddAddress}
          handleAddressOnEdit={handleAddressOnEdit}
          userId={selectedQuote?.userId?._id}

        />
      )}

      <TeamCollaboration
        teamMemberModalShow={showFollowerModal}
        selectedQuoteForTeam={selectedQuote}
        setTeamMemberModalShow={setShowFollowerModal}
        fetchDataForUser={fetchAllQoutesForRefId}
        updateQuoteData={setSelectedQuote}
        isAdmin={true}
        userEmail={selectedQuote?.userId?.email || ''}
        setTeamLoading={setTeamLoading}
      />

      <AdminCertificationComponent
        show={isCertificationsModalOpen}
        handleSelect={handleSelectCertification}
        onClose={() => setIsCertificationModalOpen(false)}
        certifications={certificationsBasedOnSelectedProcess}
        selectedQuote={selectedQuote}
      />
      <EmailRecordModal
        show={showEmailRecords}
        handleClose={handleShowEmailRecordsClick}
        emailRecords={selectedQuote?.quoteEmailRecord || []}
        setPdfModalInfo={setPdfModalInfo}



      />

      <LoggingModalComponent
        show={isLoggedModalOpen}
        onConfirm={!selectedQuote?.isLogged ? handleMoveOutFromUnloggedStage : handleMoveToUnloggedState}
        handleClose={() => setIsLoggedModalOpen(false)}
        actionType={!selectedQuote?.isLogged ? "moveOut" : "Move to Unlogged State"}

      />
      <GenericAddressComponent
        show={showGenericModal}
        setShow={setShowGenericModal}
        editAddressId={editBillingAddressId}
        getAddressById={getBillingAddressByid}
        onAddFunction={addBillingAddressFunction}
        onUpdateFunction={billingAddressUpdateFunction}
        userId={selectedQuote?.userId?._id}
        type="billing"
      />


      <Modal
        size="sm"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
            className="font-bold"
          >
            Do you want to create a new version or update the exist quote?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "left" }}>
            <h6 className="my-1 font-medium">Select the version description: </h6>
            <Form.Select
              defaultValue={versionDescriptionValue || "default"}
              onChange={handleVersionDescriptionSelect}
            >
              <option disabled value="default">
                Select an option
              </option>
              {quoteVersionDescriptions?.map((item, i) => {
                return (
                  <option value={item.id} key={i}>
                    {item.value + `  ( ${item.id} )`}
                  </option>
                );
              })}
            </Form.Select>
          </div>

          <div style={{ textAlign: "center" }}>
            <h6 style={{ textAlign: "left", margin: "30px 0 -10px 0" }}>
              Select Update Option:{" "}
            </h6>

            <Button
              className="req-quote-btn"
              onClick={() => handleUpdateQuote("new")}
            >
              New Version
            </Button>

            {!selectedQuote?.myorders ? (
              <>
                <Button
                  style={{ marginLeft: "20px" }}
                  className="req-quote-btn"
                  onClick={() => handleUpdateQuote("update")}
                >
                  Update Existing
                </Button>
              </>
            ) : (
              <></>
            )}
          </div>

          {selectedQuote?.myorders ? (
            <>
              <p style={{ color: "red", marginTop: "10px" }}>
                Cannot update the existing quotation since an order has already
                been created for that quotation.
              </p>
            </>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="req-quote-btn" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="sm"
        dialogClassName="qoute-version-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showSoModal}
        onHide={handlePoModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ fontSize: "15px" }}
          >
            Enter PO Number and Upload PO Document for Sales Order
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <div className="mb-6">
                <label>Purchase Order Number</label>
                <Form.Control
                  type="text"
                  placeholder="Enter PO Number"
                  value={poNumber ? poNumber : ""}
                  onChange={(e) => {
                    setPoNumber(e.target.value);
                  }}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-6">
                <label> PO Document</label>
                {poDocument ? (
                  <div className="downloadables">
                    {poDocument?.name ? (
                      <div className="flex items-center  gap-x-2">
                        <a
                          className="downloadables flex items-center gap-x-2"
                          href={URL.createObjectURL(poDocument)}
                          download={poDocument?.name}
                        >
                          <span>{poDocument.name} </span>
                          <DownloadIcon
                          />
                        </a>{" "}
                        <div onClick={handlePoDocumentDelete}>
                          <DeleteIcon
                          />
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="ul-files">
                      <WithDragAndDrop
                        disabled={selectedQuote?.myorders}
                        onFilesSelected={(e) => {
                          let filesForCheck = Array.from(e.target.files);
                          let isAllFilesValid = true;
                          filesForCheck.forEach((file) => {
                            if (file.size > maxFileUploadSize) {
                              isAllFilesValid = false;
                            }
                          });

                          if (!isAllFilesValid) {
                            toast.error(
                              "File size should be less than 10 MB"
                            );
                            return;
                          }
                          setPoDocument(e.target.files[0]);
                        }}
                        additionalClassNames="w-full"
                      >
                        <div className="file-button">
                          <input
                            type="file"
                            name="file-input"
                            id="file-input"
                            className="file-input__input"
                            onChange={(e) => {
                              let filesForCheck = Array.from(e.target.files);
                              let isAllFilesValid = true;
                              filesForCheck.forEach((file) => {
                                if (file.size > maxFileUploadSize) {
                                  isAllFilesValid = false;
                                }
                              });

                              if (!isAllFilesValid) {
                                toast.error(
                                  "File size should be less than 10 MB"
                                );
                                return;
                              }
                              setPoDocument(e.target.files[0]);
                            }}
                          />
                          <label htmlFor="file-input" className=" white-btn">
                            {" "}
                            <span>Browse</span>
                          </label>
                        </div>
                      </WithDragAndDrop>
                    </div>
                  </>
                )}

              </div>
            </Col>
            <Col>
              <div className="text-red-500 text-sm ">
                {poModalError}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {!isPoLoaderActivated ? <Button className="req-quote-btn" onClick={handleProceedToPO}>
            Proceed To Sales Order
          </Button> : <Button className="req-quote-btn flex items-center justify-center " >
            <LucidLoader />
          </Button>}
          <Button className="req-quote-btn" onClick={handlePoModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        // dialogClassName="d-flex align-items-center justify-content-center custom-modal-view-order2"
        // aria-labelledby="contained-modal-title-vcenter"
        className="border border-green-500"
        centered
        show={showDQModal}
        onHide={() => {
          setShowDQModal(false);
          setDownloadQuoteModalError('');
          setFunctionalityForDQ('');
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="example-modal-sizes-title-sm"
            style={{ fontSize: "15px" }}
          >
            {functionalityForDQ === "download-quote"
              ? "Download quotation"
              : functionalityForDQ === "proceed-po"
                ? "Sales Order"
                : "Send To Email"}

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {downloadQuoteModalError ? (
            <div className=" bg-red-100 text-red-700 text-sm font-medium px-3 py-1 rounded">
              {downloadQuoteModalError}
            </div>
          ) : null}
          <div className="  grid grid-cols-2 gap-x-2 mt-4">


            <div >
              <h6 className="font-bold  my-2">
                Select shipping address
              </h6>
              <div className="billing-form">
                <div className="address">
                  <div className="max-h-[300px] min-h-[300px] overflow-y-scroll">
                    {addressValues?.address?.map((el, id) => (
                      <div className="singleAddress" key={id}>
                        <div style={{ display: "flex" }}>
                          <input
                            className="btn-radio"
                            type="radio"
                            value={el._id}
                            checked={addressValues.shippingAddress == el._id}
                            name="rd"
                            style={{ marginRight: "5px" }}
                            onChange={(e) => {
                              setError({
                                ...error,
                                shippingAddress: "",
                              });
                              setIsNoShippingAddressSelected(false);
                              setAddressValues({
                                ...addressValues,
                                shippingAddress: el._id,
                                addressline1: el.addressLineOne,
                                addressline2: el.addressLineTwo,
                                city: el.city,
                                country: el.country,
                                state: el.state,
                                zipCode: el.postalCode,
                                firstName: el.firstName,
                                lastName: el.lastName,
                              });
                            }}
                          />
                          <div className="address">
                            <div className="name">
                              {el?.firstName} {el?.lastName || ""}
                            </div>
                            <div className="add">
                              {el?.addressLineOne} {el?.addressLineTwo} {el?.city}{" "}
                              {el?.state} {el.postalCode} {el.country}
                            </div>
                          </div>
                        </div>
                        <div className="buttons">
                          <div className="edit" onClick={() => editHandler(id)}>
                            Edit
                          </div>
                          |
                          <div className="delete" onClick={() => deleteData(id)}>
                            Delete
                          </div>
                        </div>
                      </div>
                    ))}
                    {functionalityForDQ == "download-quote" || functionalityForDQ == "send-to-email" ? <div className="singleAddress" >
                      <div style={{ display: "flex" }}>
                        <input
                          className="btn-radio"
                          type="radio"
                          checked={isNoShippingAddressSelected}
                          name="rd"
                          style={{ marginRight: "5px" }}
                          onChange={(e) => {
                            setIsNoShippingAddressSelected(true)
                            setAddressValues({
                              ...addressValues,
                              shippingAddress: "",
                              addressline1: "",
                              addressline2: "",
                              city: "",
                              country: "",
                              state: "",
                              zipCode: "",
                              firstName: "",
                              lastName: "",
                            });
                          }}
                        />
                        <div className="address">
                          <div className="name">
                            No Shipping Address
                          </div>
                        </div>
                      </div>
                    </div> : null}
                  </div>

                  <div className="allAddress">
                    <div className="link"></div>
                    {addressValues?.address?.length >= 5 ? (
                      <div
                        className="addNew"
                        style={{ cursor: "auto", opacity: "0.5" }}
                      >
                        + Add New Address
                      </div>
                    ) : (
                      <div className="addNew" onClick={addNewHandler}>
                        + Add New Address
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <h6 className="font-bold  my-2">
                Select billing address
              </h6>
              <div className="billing-form">
                <div className="address">
                  <div className="max-h-[300px] min-h-[300px] overflow-y-scroll">
                    {billingAddressForUser?.map((el, id) => (
                      <div className="singleAddress" key={id}>
                        <div style={{ display: "flex" }}>
                          <input
                            className="btn-radio"
                            type="radio"
                            value={el._id}
                            checked={addressValues.billingAddress == el._id}
                            name="billing"
                            style={{ marginRight: "5px" }}
                            onChange={(e) => {
                              setError({
                                ...error,
                                billingAddress: "",
                              });
                              setIsNoBillingAddressSelected(false);
                              setAddressValues({
                                ...addressValues,
                                billingAddress: el._id,

                              });
                            }}
                          />
                          <div className="address">
                            <div className="name">
                              {el?.firstName} {el?.lastName || ""}
                            </div>
                            <div className="add">
                              {el?.addressLineOne} {el?.addressLineTwo} {el?.city}{" "}
                              {el?.state} {el.postalCode} {el.country}
                            </div>
                          </div>
                        </div>
                        <div className="buttons">
                          <div className="edit" onClick={() => handleEditBillingAddress(el?._id)}>
                            Edit
                          </div>
                          |
                          <div className="delete" onClick={() => deleteBilllingAddress(el?._id)}>
                            Delete
                          </div>
                        </div>
                      </div>
                    ))}
                    {functionalityForDQ == "download-quote" || functionalityForDQ == "send-to-email" ? <div className="singleAddress" >
                      <div style={{ display: "flex" }}>
                        <input
                          className="btn-radio"
                          type="radio"
                          checked={isNoBillingAddressSelected}
                          name="billing"
                          style={{ marginRight: "5px" }}
                          onChange={(e) => {
                            setIsNoBillingAddressSelected(true)
                            setAddressValues({
                              ...addressValues,
                              billingAddress: "",
                            });
                          }}
                        />
                        <div className="address">
                          <div className="name">
                            No Billing Address
                          </div>
                        </div>
                      </div>
                    </div> : null}
                  </div>

                  <div className="allAddress">
                    <div className="link"></div>
                    {billingAddressForUser?.length >= 5 ? (
                      <div
                        className="addNew"
                        style={{ cursor: "auto", opacity: "0.5" }}
                      >
                        + Add New Address
                      </div>
                    ) : (
                      <div className="addNew" onClick={addNewBillingAddress}>
                        + Add New Address
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {functionalityForDQ == "download-quote" ? (
            <Button onClick={handleDownload} className="req-quote-btn">
              Download Quotation
            </Button>
          ) : functionalityForDQ == "send-to-email" ? (
            <Button
              onClick={() => {
                setDownloadQuoteModalError();
                if (!addressValues.shippingAddress && !isNoShippingAddressSelected) {
                  setDownloadQuoteModalError(
                    "Please select a valid shipping address to download quotation."
                  );
                  return;
                }
                if (!addressValues.billingAddress && !isNoBillingAddressSelected) {
                  setDownloadQuoteModalError(
                    "Please select a valid billing address to download quotation."
                  );
                  return;
                }
                setShowDQModal(false);
                setShowCaptchaModal(true);
              }}
              className="req-quote-btn"
            >
              Send To Email
            </Button>
          ) : functionalityForDQ == "proceed-po" ? (
            <Button
              onClick={() => {
                if (!addressValues.shippingAddress && !isNoShippingAddressSelected) {
                  setDownloadQuoteModalError(
                    "Please select a valid shipping address to proceed."
                  );
                  return;
                }
                if (!addressValues.billingAddress && !isNoBillingAddressSelected) {
                  setDownloadQuoteModalError(
                    "Please select a valid billing address to proceed."
                  );
                  return;
                }
                setShowSoModal(true);
                setShowDQModal(false);
                setDownloadQuoteModalError('');
              }
              }
              className="req-quote-btn"
            >
              Proceed
            </Button>
          ) : (
            ""
          )}


          <Button
            onClick={() => setShowDQModal(false)}
            className="req-quote-btn"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Chat RefId={selectedQuote?.RefId} open={open} onDrawerClose={onClose} />
      <Sidebar />
      <span className="min-w-[1250px]" style={{ width: "100%" }}>
        <div className="center-heading">
          <h1 className="text-2xl font-bold  mt-3">Quote Details</h1>
        </div>


        <div className="right-container">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexWrap: "wrap",
              marginTop: "-20px",
            }}
          >
            <div className="qoute-version-block flex flex-col">
              <label className="qoute-version-label">Project Name :</label>
              <p className="flex items-center">{selectedQuote?.projectName} <span onClick={() => setShowProjectNameModal(true)}><EditIcon /></span></p>
            </div>

            <div className="qoute-version-block">
              <label className="qoute-version-label">Selected Process :</label>
              <p
                style={{
                  wordWrap: "break-word",
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                  width: "300px",
                }}
              >
                {selectedQuote
                  ? processType.map((val, i) => {
                    if (val.id == selectedQuote?.selectedProcess) {
                      return val.name;
                    }
                  })
                  : null}
              </p>
            </div>

            <div className="qoute-version-block">
              <label className="qoute-version-label">Apply To All Parts : </label>
              <p
                style={{
                  wordWrap: "break-word",
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                  width: "300px",
                }}
              >
                {selectedQuote?.sameForAllField ? "Yes" : "No"}
              </p>
            </div>
            <div className="qoute-version-block">
              <label className="qoute-version-label">Selected version : </label>
              <p
                style={{
                  wordWrap: "break-word",
                  wordBreak: "break-all",
                  whiteSpace: "normal",
                  width: "300px",
                }}
              >
                {selectedQuote?.version}
              </p>
            </div>
          </div>
          {selectedQuote && !selectedQuote?.myorders && (
            (
              selectedQuote?.selectedProcess >= 3 ? (!selectedQuote.isSent && !selectedQuote.isEmailSent)
                : selectedQuote.isManualReviewRequiredAutomatedProcess && !(selectedQuote.isSent || selectedQuote.isEmailSent)
            )
          ) ? <div className="bg-red-500 py-1 my-2">
            <div className=" text-white">This quotation has not been sent yet. Please click "Mark as Sent" below or send the quotation using the "Send Email" button.</div>
          </div> : null}
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              margin: "10px 0px",
              border: "1px solid gray",
            }}
          >
            <table
              className="qoute-version-table-admin"
              style={{ border: "1px solid black", width: "100%" }}
            >
              <thead>
                <tr className="heading-row ">
                  <th>First name</th>
                  <th>Last name</th>
                  <th>Email id</th>
                  <th>Company name</th>
                  <th>Created on</th>
                  <th>Updated on</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  className={" h-11"}
                  style={{ cursor: "pointer" }}
                >
                  <td>{selectedQuote?.userId?.firstName}</td>
                  <td>{selectedQuote?.userId?.lastName || ""}</td>
                  <td>{selectedQuote?.userId?.email}</td>
                  <td>{selectedQuote?.userId?.companySiteId?.companyName}</td>
                  <td>{moment(selectedQuote?.createdAt).format('YYYY-MM-DD')}</td>
                  <td>{moment(selectedQuote?.updatedAt).format('YYYY-MM-DD')}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              margin: "10px 0px",
              border: "1px solid gray",
            }}
          >
            <table
              className="qoute-version-table-admin"
              style={{ border: "1px solid black", width: "100%" }}
            >
              <thead>
                <tr className="heading-row ">
                  <th>Select Version</th>
                  <th>Version Description</th>
                  <th>Date</th>
                  <th>Rapid</th>
                  <th>LeadTime 1</th>
                  <th>Standard</th>
                  <th>LeadTime 2</th>
                  <th>Economy</th>
                  <th>LeadTime 3</th>
                  <th>User Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              {!isSecondaryDataLoading ? <tbody>
                {[
                  ...allVersionForRefId
                ].map((quoteItem, index) => {
                  const versionDescriptionText = quoteItem.versionDescription
                    ? `${quoteVersionDescriptions.find(
                      (item) => item.id === quoteItem.versionDescription
                    )?.value || "Not found"}  ( ${quoteItem.versionDescription} )`
                    : "Not found";
                  const userName = (
                    <>
                      {(quoteItem?.userId?.firstName || "") + " " + (quoteItem?.userId?.lastName || "")}
                      <br />
                      {quoteItem?.userId ? `(${quoteItem.userId.email?.split("@")[0]})` : ""}
                    </>
                  );
                  return (
                    <tr
                      ref={(el) => versionScrollRef[quoteItem._id] = el}
                      key={index}
                      className={quoteItem._id === selectedQuote._id ? "highlight-row" : ""}
                      onClick={() => {
                        navigate(`/admin/admin-quote/${quoteItem._id}`);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td>Version {quoteItem?.userVersionName ? `${quoteItem?.version}-${quoteItem.userVersionName}` : `${quoteItem?.version}`}</td>
                      <td>{versionDescriptionText}</td>
                      <td>{moment(quoteItem.createdAt).format("YYYY-MM-DD")}</td>
                      <td>
                        {quoteItem.price1
                          ? currencyFormatter((quoteItem.price1 || 0) + (quoteItem?.shippingCharge1 || 0) + (quoteItem?.orderCertificationsCost || 0))
                          : currencyFormatter(0)}
                      </td>
                      <td>{Number(quoteItem.leadTime1) > 0 ? quoteItem.leadTime1 : 0}</td>
                      <td>
                        {quoteItem.price2
                          ? currencyFormatter((quoteItem.price2 || 0) + (quoteItem?.shippingCharge2 || 0) + (quoteItem?.orderCertificationsCost || 0))
                          : currencyFormatter(0)}
                      </td>
                      <td>{Number(quoteItem.leadTime2) > 0 ? quoteItem.leadTime2 : 0}</td>
                      <td>
                        {quoteItem.price3
                          ? currencyFormatter((quoteItem.price3 || 0) + (quoteItem?.shippingCharge3 || 0) + (quoteItem?.orderCertificationsCost || 0))
                          : currencyFormatter(0)}
                      </td>
                      <td>{Number(quoteItem.leadTime3) > 0 ? quoteItem.leadTime3 : 0}</td>
                      <td>{userName}</td>
                      <td>
                        {quoteItem?.quoteStatus}
                      </td>
                    </tr>
                  );
                })}
              </tbody> : <AdminLoadingComponent rows={1} columns={11} />}

            </table>
          </div>
          {selectedQuote ? (
            <div className="quotes-table">
              <table className="table table-fixed ">
                {selectedQuote?.selectedProcess >= 3 ? (
                  <>
                    <thead>
                      <tr>
                        {selectedQuote?.partsData.length > 1 ? <th scope="col" className="w-[70px]">Action</th> : null}
                        <th scope="col" > <span className="!ms-12">Snapshot</span> </th>

                        <th scope="col" className="w-[250px]">File Name</th>
                        <th scope="col" className="w-[200px">Part Description</th>
                        <th scope="col" className="w-[100px]  border-yellow-500">Qty</th>
                        <th scope="col" className="w-[120px]">Rapid</th>
                        <th scope="col" className="w-[120px]">Standard</th>
                        <th scope="col" className="w-[120px]">Economy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedQuote?.partsData?.length > 0 &&
                        selectedQuote?.partsData.map((item, index) => {
                          return (
                            <tr key={index}>
                              {selectedQuote?.partsData.length > 1 ? <td >
                                <div className="flex mx-1 col-span-1 flex-col h-44 justify-evenly items-center gap-2 ">
                                  {index != 0 ? <Button className="border border-gray-300 rounded" variant="outline" onClick={() => moveLineItemToXindex(index, -1)}><ArrowUp additionalClasses={"h-4 w-4"} /></Button> : null}
                                  {(selectedQuote?.partsData?.length - 1) != index ? < Button className="border border-gray-300 rounded" variant="outline" onClick={() => moveLineItemToXindex(index, 1)}><ArrowDown additionalClasses={"h-4 w-4"} /></Button> : null}
                                </div>
                              </td> : null}
                              <td className="flex flex-col items-center justify-center">
                                <WithDragAndDrop
                                  onFilesSelected={(e) => handleSnapShotUpload(e, item?._id, !!item?.thumbnail)}
                                  additionalClassNames="flex flex-col items-center justify-center p-2 "
                                  disabled={selectedQuote?.myorders}

                                >
                                  {!isDfmDataLoading ? <ThreeDViewerComponent
                                    selectedProcess={selectedQuote.selectedProcess}
                                    item={item}
                                  /> : <LucidLoader additionalClass={'text-primaryColor'} />}
                                  <div class="flex items-start justify-start gap-x-2 ms-2 mt-3 w-full">
                                    <label
                                      for={`file-upload-${index}`}
                                      class={`cursor-pointer text-center rounded text-[12px] text-black bg-gray-200 shadow-md py-2 px-3 transition duration-300 ${item?.thumbnail ? 'w-1/2' : 'w-full'
                                        }`}
                                    >
                                      Upload
                                    </label>
                                    <input
                                      onChange={(e) => handleSnapShotUpload(e, item?._id, !!item?.thumbnail)}
                                      id={`file-upload-${index}`}
                                      type="file"
                                      accept="image/*"
                                      class="hidden"
                                    />

                                    {item?.thumbnail && (
                                      <button
                                        onClick={() => handleDeleteSnapshot(item?._id)}
                                        class="w-1/2 text-center rounded text-[12px] text-white bg-red-500 hover:bg-red-600 shadow-md py-2 px-3 transition duration-300"
                                      >
                                        Delete
                                      </button>
                                    )}
                                  </div>
                                </WithDragAndDrop>
                              </td>
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  wordBreak: "break-all",
                                  whiteSpace: "normal",
                                }}
                              >
                                <div
                                  className="prd-thumb"
                                  style={{ color: "dodgerblue" }}
                                >
                                  <p
                                    style={{ color: "dodgerblue" }}

                                  >
                                    {item ? (
                                      <>
                                        {item?.selectedFile || item?.linePartName ? (
                                          <FileName
                                            fileName={
                                              item?.selectedFile?.originalname ||
                                              item?.linePartName ||
                                              "SamplePart.stp"
                                            }
                                            onDelete={() => handleDeleteFile("3D", index)}
                                            onDownload={
                                              item?.selectedFile
                                                ? async () => {
                                                  const originalname = item?.selectedFile?.originalname;
                                                  if (originalname && originalname.endsWith(".pdf")) {
                                                    const signedUrl = await getPresignedUrlForFile(
                                                      item.selectedFile.bucket,
                                                      item.selectedFile.key
                                                    );
                                                    setPdfModalInfo({
                                                      show: true,
                                                      pdfUrl: signedUrl,
                                                      fileName: originalname,
                                                    });
                                                    return;
                                                  }
                                                  await downloadFileFromS3(item.selectedFile);
                                                }
                                                : undefined
                                            }
                                          />
                                        ) : (
                                          <>
                                            <WithDragAndDrop
                                              disabled={selectedQuote?.myorders}
                                              additionalClassNames="w-full"
                                              multiple={false}
                                              onFilesSelected={(e) => {
                                                handle3DFileUpload(e, index)
                                              }}

                                            >
                                              <div className="file-button !cursor-pointer relative">
                                                <input
                                                  name="file-input-3d"
                                                  id={`file-input-3d-${index}`}
                                                  className="file-input__input"
                                                  type="file"
                                                  onChange={(e) => handle3DFileUpload(e, index)}
                                                />
                                                <label
                                                  className="icon-btn cursor-pointer"
                                                  htmlFor={`file-input-3d-${index}`}
                                                >
                                                  <span className="flex items-center rounded text-xs link-btn edit-btn  p-2">
                                                    <UploadIcon additionalClass="h-4 w-4" />
                                                    <span className="text-primaryColor">Upload 3D File</span>
                                                  </span>
                                                </label>
                                              </div>
                                            </WithDragAndDrop>
                                          </>
                                        )}
                                      </>
                                    ) : null}


                                  </p>
                                </div>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  wordWrap: "break-word",
                                  wordBreak: "break-all",
                                  whiteSpace: "normal",
                                  width: "250px",
                                }}
                              >

                                <AutoResizingTextarea
                                  maxLength={150}
                                  value={item?.description}
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "description",
                                      e.target.value
                                    )}

                                />
                              </td>

                              <td>
                                <FormControl
                                  type="text"
                                  value={item?.Qty}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "Qty",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Qty"
                                  onWheel={numberInputOnWheelPreventChange}
                                />
                              </td>
                              <td>
                                <FormControl
                                  placeholder="Enter price"
                                  value={item?.price1 ? item?.price1 : ""}
                                  type="number"
                                  onWheel={numberInputOnWheelPreventChange}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "price1",
                                      e.target.value
                                    )
                                  }
                                  min={0}
                                />
                              </td>
                              <td>
                                <FormControl
                                  placeholder="Enter price"
                                  value={item?.price2 ? item?.price2 : ""}
                                  type="number"
                                  onWheel={numberInputOnWheelPreventChange}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "price2",
                                      e.target.value
                                    )
                                  }
                                  min={0}
                                />
                              </td>

                              <td>
                                <FormControl
                                  placeholder="Enter price"
                                  value={item.price3 ? item.price3 : ""}
                                  type="number"
                                  onWheel={numberInputOnWheelPreventChange}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "price3",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}

                      <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td id="leadTimeTitle">Lines Total</td>
                        <td></td>
                        <td>
                          {currencyFormatter(
                            linesTotal[0] ? linesTotal[0].toFixed(2) : 0
                          )}
                        </td>
                        <td>
                          {currencyFormatter(
                            linesTotal[1] ? linesTotal[1].toFixed(2) : 0
                          )}
                        </td>
                        <td>
                          {currencyFormatter(
                            linesTotal[2] ? linesTotal[2].toFixed(2) : 0
                          )}
                        </td>
                      </tr>

                      <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td>
                          <div onClick={() => {
                            setIsCertificationModalOpen(true);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }} className='flex items-center justify-center border py-2 w-max px-4 rounded '>
                            <EyeIcon />
                            <p className="whitespace-nowrap text-[14px]">View Certifications</p>
                          </div>
                        </td>
                        <td></td>

                        <td colSpan={3}>
                          <div >
                            <FormControl
                              type="number"
                              style={{ width: "100%" }}
                              className="text-center"
                              onWheel={numberInputOnWheelPreventChange}
                              value={
                                selectedQuote?.orderCertificationsCost
                                  ? selectedQuote?.orderCertificationsCost
                                  : ""
                              }
                              placeholder="Charge"
                              onKeyDown={(e) =>
                                ["e", "E", "+", "-"].includes(e.key) &&
                                e.preventDefault()
                              }
                              onChange={(e) =>
                                handleCertificationCostChange(e.target.value)
                              }
                              min={0}
                            />
                          </div>

                        </td>
                      </tr>

                      <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td id="leadTimeTitle">Lead Time</td>
                        <td></td>
                        <td>
                          <FormControl
                            type="text"
                            onWheel={numberInputOnWheelPreventChange}
                            style={{ width: "100%" }}
                            value={leadTime[0] ? Number(leadTime[0]) > 0 ? leadTime[0] : 0 : ""}
                            placeholder="Days"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleLeadTimeChange(e, 0)}
                          />
                          {/* <p style={{ marginLeft: "10px" }}>
                            {leadTime[0]
                              ? `(${Math.floor(leadTime[0])}
                              } weeks)`
                              : "NA"}{" "}
                          </p> */}
                        </td>

                        <td>
                          <FormControl
                            type="text"
                            style={{ width: "100%" }}
                            onWheel={numberInputOnWheelPreventChange}
                            value={leadTime[1] ? Number(leadTime[1]) > 0 ? leadTime[1] : 0 : ""}
                            placeholder="Days"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleLeadTimeChange(e, 1)}
                          />
                          {/* <p style={{ marginLeft: "10px" }}>
                            {leadTime[1]
                              ? `(${Math.floor(leadTime[1] / 7)}-${Math.floor(leadTime[1] / 7) + 1
                              } weeks)`
                              : "NA"}{" "}
                          </p> */}
                        </td>
                        <td>
                          <FormControl
                            type="text"
                            style={{ width: "100%" }}
                            onWheel={numberInputOnWheelPreventChange}
                            value={leadTime[2] ? Number(leadTime[2]) > 0 ? leadTime[2] : 0 : ""}
                            placeholder="Days"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleLeadTimeChange(e, 2)}
                          />
                          {/* <p>
                            {leadTime[2]
                              ? leadTime[2] +
                              " Days" +
                              `(${Math.floor(leadTime[2] / 7)}-${Math.floor(leadTime[2] / 7) + 1
                              } weeks)`
                              : "NA"}{" "}
                          </p> */}
                        </td>
                      </tr>

                      <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td id="leadTimeTitle">Shipping  </td>
                        <td></td>
                        <td>
                          <FormControl
                            type="number"
                            style={{ width: "100%" }}
                            onWheel={numberInputOnWheelPreventChange}
                            value={
                              selectedQuote?.shippingCharge1
                                ? selectedQuote?.shippingCharge1
                                : ""
                            }
                            placeholder="Cost"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleShippingChargeChange(e, 1)}
                            min={0}
                          />
                        </td>

                        <td>
                          <FormControl
                            type="number"
                            style={{ width: "100%" }}
                            onWheel={numberInputOnWheelPreventChange}
                            value={
                              selectedQuote?.shippingCharge2
                                ? selectedQuote?.shippingCharge2
                                : ""
                            }
                            placeholder="Cost"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleShippingChargeChange(e, 2)}
                            min={0}
                          />
                        </td>
                        <td>
                          <FormControl
                            type="number"
                            style={{ width: "100%" }}
                            onWheel={numberInputOnWheelPreventChange}
                            value={
                              selectedQuote?.shippingCharge3
                                ? selectedQuote?.shippingCharge3
                                : ""
                            }
                            placeholder="Cost"
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleShippingChargeChange(e, 3)}
                            min={0}
                          />
                        </td>
                      </tr>
                      <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td id="leadTimeTitle">Shipping Days</td>
                        <td></td>

                        <td>
                          <FormControl
                            // type="number"
                            style={{ width: "100%" }}
                            // onWheel={numberInputOnWheelPreventChange}
                            value={
                              !Number.isNaN(selectedQuote?.shippingDays1)
                                ? selectedQuote?.shippingDays1
                                : ""
                            }
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleShippingLeadTimeChange(e, 0)}
                          />
                        </td>
                        <td>
                          <FormControl
                            style={{ width: "100%" }}
                            value={
                              !Number.isNaN(selectedQuote?.shippingDays2)
                                ? selectedQuote?.shippingDays2
                                : ""
                            }
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleShippingLeadTimeChange(e, 1)}
                          />
                        </td>
                        <td>
                          <FormControl
                            style={{ width: "100%" }}
                            value={
                              !Number.isNaN(selectedQuote?.shippingDays3)
                                ? selectedQuote?.shippingDays3
                                : ""
                            }
                            onKeyDown={(e) =>
                              ["e", "E", "+", "-"].includes(e.key) &&
                              e.preventDefault()
                            }
                            onChange={(e) => handleShippingLeadTimeChange(e, 2)}

                          />
                        </td>
                      </tr>

                      <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td id="leadTimeTitle">Total </td>
                        <td></td>
                        <td>
                          {linesTotal[0] ? <h6>
                            {currencyFormatter(
                              linesTotal[0]
                                ? (
                                  linesTotal[0] +
                                  parseFloat(selectedQuote?.shippingCharge1 || 0) + (selectedQuote?.orderCertificationsCost || 0)
                                )
                                : 0
                            )}
                          </h6> : null}
                        </td>

                        <td>
                          {linesTotal[1] ? <h6>
                            {currencyFormatter(
                              linesTotal[1]
                                ? (
                                  linesTotal[1] +
                                  parseFloat(selectedQuote?.shippingCharge2 || 0) + (selectedQuote?.orderCertificationsCost || 0)
                                )
                                : 0
                            )}
                          </h6> : null}
                        </td>
                        <td>
                          {linesTotal[2] ? <h6>
                            {currencyFormatter(linesTotal[2] ? (
                              linesTotal[2] +
                              parseFloat(selectedQuote?.shippingCharge3 || 0) + (selectedQuote?.orderCertificationsCost || 0)
                            ) : 0

                            )}
                          </h6> : null}
                        </td>
                      </tr>
                      {selectedQuote?.userTargetCost ? <tr className="leadTimeRow">
                        {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                        <td></td>
                        <td></td>
                        <td id="leadTimeTitle">Requested Target Cost</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <h6>
                            {currencyFormatter(
                              selectedQuote?.userTargetCost
                                ? (
                                  selectedQuote?.userTargetCost
                                ).toFixed(2)
                                : 0
                            )}
                          </h6>
                        </td>

                      </tr> : null}
                    </tbody>
                  </>
                ) : (
                  <>
                    <thead>
                      <tr>
                        {selectedQuote?.partsData.length > 1 ? <th scope="col" className="w-[70px]">Action</th> : null}
                        <th scope="col" > <span className="!ms-12">Snapshot</span> </th>
                        <th scope="col"> Files </th>
                        <th scope="col" className="w-[300px]">Part Description</th>
                        <th scope="col" className="w-[100px]  border-yellow-500">Qty</th>
                        <th scope="col" className="w-[120px]" >Rapid</th>
                        <th scope="col" className="w-[120px]" >Standard</th>
                        <th scope="col" className="w-[120px]" >Economy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedQuote?.partsData.length > 0 &&
                        selectedQuote?.partsData.map((item, index) => {
                          return (
                            <tr key={index}>
                              {selectedQuote?.partsData.length > 1 ? <td>
                                <div className="flex mx-1 col-span-1 flex-col h-44 justify-evenly items-center gap-2 ">
                                  {index != 0 ? <Button className="border border-gray-300 rounded" variant="outline" onClick={() => moveLineItemToXindex(index, -1)}><ArrowUp additionalClasses={"h-4 w-4"} /></Button> : null}
                                  {(selectedQuote?.partsData?.length - 1) != index ? < Button className="border border-gray-300 rounded" variant="outline" onClick={() => moveLineItemToXindex(index, 1)}><ArrowDown additionalClasses={"h-4 w-4"} /></Button> : null}
                                </div>
                              </td> : null}
                              <td className="flex flex-col items-center justify-center" >
                                <WithDragAndDrop
                                  disabled={selectedQuote?.myorders}
                                  onFilesSelected={(e) => handleSnapShotUpload(e, item?._id, !!item?.thumbnail)}
                                  additionalClassNames="flex flex-col items-center justify-center p-2 "

                                >
                                  {
                                    !isDfmDataLoading ? <ThreeDViewerComponent
                                      selectedProcess={selectedQuote.selectedProcess}
                                      item={item}
                                    /> : <LucidLoader additionalClass={'text-primaryColor'} />
                                  }
                                  <div class="flex items-start justify-start gap-x-2 ms-2 mt-3 w-full">
                                    <label
                                      for={`file-upload-${index}`}
                                      class={`cursor-pointer text-center rounded text-[12px] text-black bg-gray-200 shadow-md py-2 px-3 transition duration-300 ${item?.thumbnail ? 'w-1/2' : 'w-full'
                                        }`}
                                    >
                                      Upload
                                    </label>
                                    <input
                                      onChange={(e) => handleSnapShotUpload(e, item?._id, !!item?.thumbnail)}
                                      id={`file-upload-${index}`}
                                      type="file"
                                      accept="image/*"
                                      class="hidden"
                                    />

                                    {item?.thumbnail && (
                                      <button
                                        onClick={() => handleDeleteSnapshot(item?._id)}
                                        class="w-1/2 text-center rounded text-[12px] text-white bg-red-500 hover:bg-red-600 shadow-md py-2 px-3 transition duration-300"
                                      >
                                        Delete
                                      </button>
                                    )}
                                  </div>
                                </WithDragAndDrop>


                              </td>
                              <td
                                style={{
                                  wordWrap: "break-word",
                                  wordBreak: "break-all",
                                  whiteSpace: "normal",
                                  minWidth: "150px",
                                  cursor: "pointer",
                                }}

                              >
                                <div>
                                  <p
                                  >
                                    {item?.selectedFile ? <FileName
                                      fileName={item?.selectedFile?.originalname || item?.linePartName || "SamplePart.stp"}
                                      onDelete={() => handleDeleteFile('3D', index)}
                                      onDownload={
                                        item?.selectedFile?.originalname
                                          ? async () => {
                                            const { originalname } = item?.selectedFile;
                                            if (originalname && originalname.endsWith('.pdf')) {
                                              const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                              setPdfModalInfo({
                                                show: true,
                                                pdfUrl: signedUrl,
                                                fileName: originalname,
                                              })
                                              return;
                                            }
                                            await downloadFileFromS3(item?.selectedFile)
                                          }
                                          : undefined
                                      }
                                    /> : <>
                                      <WithDragAndDrop
                                        disabled={selectedQuote?.myorders}
                                        additionalClassNames="w-full"
                                        multiple={false}
                                        onFilesSelected={(e) => {
                                          handle3DFileUpload(e, index)

                                        }}>
                                        <div className="file-button !cursor-pointer relative">
                                          <input
                                            name="file-input-3d"
                                            id={`file-input-3d-${index}`}
                                            className={`file-input__input `}
                                            type="file"
                                            onChange={(e) => handle3DFileUpload(e, index)}
                                          />
                                          <label
                                            className={`icon-btn  cursor-pointer`}
                                            htmlFor={`file-input-3d-${index}`}

                                          >
                                            <span
                                              className={`flex  items-center  rounded text-xs link-btn edit-btn my-2 p-2"
                                                }`}
                                            >
                                              <UploadIcon
                                                additionalClass={`h-4 w-4`}
                                              />
                                              <span className={"text-primaryColor"}>
                                                Upload 3D File
                                              </span>
                                            </span>
                                          </label>
                                        </div>
                                      </WithDragAndDrop>
                                    </>}

                                  </p>
                                </div>
                                <div className="my-2" style={{ color: "dodgerblue" }}>
                                  <p className=" flex  items-center  gap-x-2 ">
                                    {item.twoDFile ? (
                                      <>
                                        <FileName
                                          fileName={item.twoDFile.originalname}
                                          onDelete={() => handleDeleteFile('2D', index)}
                                          onDownload={async () => {
                                            const { originalname } = item?.twoDFile;
                                            if (originalname && originalname.endsWith('.pdf')) {
                                              const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                              setPdfModalInfo({
                                                show: true,
                                                pdfUrl: signedUrl,
                                                fileName: originalname,
                                              })
                                              return;
                                            }
                                            await downloadFileFromS3(item?.twoDFile)
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <WithDragAndDrop
                                          disabled={selectedQuote?.myorders}
                                          additionalClassNames="w-full"
                                          multiple={false}
                                          onFilesSelected={(e) => handle2DFileUpload(e, index)}>
                                          <div className="file-button !cursor-pointer relative">
                                            <input
                                              name="file-input-2d"
                                              id={`file-input-2d-${index}`}
                                              className={`file-input__input `}
                                              type="file"
                                              onChange={(e) => handle2DFileUpload(e, index)}
                                            />
                                            <label
                                              className={`icon-btn  cursor-pointer`}
                                              htmlFor={`file-input-2d-${index}`}

                                            >
                                              <span
                                                className={`flex  items-center  rounded text-xs link-btn my-2 edit-btn  p-2"
                                                }`}
                                              >
                                                <UploadIcon
                                                  additionalClass={`h-4 w-4`}
                                                />
                                                <span className={"text-primaryColor"}>
                                                  Technical Drawing
                                                </span>
                                              </span>
                                            </label>
                                          </div>
                                        </WithDragAndDrop>
                                      </>
                                    )}
                                  </p>
                                </div>
                              </td>



                              <td
                                style={{
                                  textAlign: "left",
                                  wordWrap: "break-word",
                                  wordBreak: "break-all",
                                  whiteSpace: "normal",
                                  width: "250px",
                                }}
                              >
                                <div
                                  className="desc-part"
                                  style={{ width: "100%" }}
                                >
                                  <AutoResizingTextarea
                                    maxLength={150}
                                    value={item?.description}
                                    onChange={(e) =>
                                      handleItemInformationChange(
                                        index,
                                        "description",
                                        e.target.value
                                      )}

                                  />
                                  {selectedQuote.selectedProcess == 1 ?
                                    <>
                                      <PartMetadataChangeComponent

                                        item={item}
                                        selectedProcess={selectedQuote.selectedProcess}
                                        allCncMachineData={allCncMachineData}
                                        index={index}
                                        handleMaterialMasterChange={handleMaterialMasterChange}
                                        sameForAllField={selectedQuote?.sameForAllField}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                        selectedQuote={selectedQuote}
                                        isOutOfSpec={item?.isOutOfSpec}
                                        setSelectedQuote={setSelectedQuote}
                                        message={selectedQuote?.myorders ? 'Cannot update the existing quotation since an order has already been created for that quotation.' : null}
                                      />
                                    </>
                                    :
                                    <>
                                      <PartMetadataChangeComponent
                                        selectedProcess={selectedQuote.selectedProcess}
                                        item={item}
                                        isOutOfSpec={item?.isOutOfSpec}
                                        masterThreeDTechnologyData={masterThreeDTechnologyData}
                                        index={index}
                                        handleMaterialMasterChange={handleMaterialMasterChange}
                                        sameForAllField={selectedQuote?.sameForAllField}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                        selectedQuote={selectedQuote}
                                        setSelectedQuote={setSelectedQuote}
                                        message={selectedQuote?.myorders ? 'Cannot update the existing quotation since an order has already been created for that quotation.' : null}
                                      />
                                    </>}

                                </div>
                              </td>

                              <td>
                                <FormControl
                                  type="text"
                                  value={item?.Qty}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "Qty",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Qty"
                                  onWheel={numberInputOnWheelPreventChange}
                                  style={{ minWidth: "50px" }}
                                />
                              </td>
                              <td>
                                <FormControl
                                  placeholder="Enter price"
                                  value={item?.price1 ? item?.price1 : ""}
                                  type="number"
                                  onWheel={numberInputOnWheelPreventChange}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "price1",
                                      e.target.value
                                    )
                                  }
                                  min={0}
                                />
                              </td>
                              <td>
                                <FormControl
                                  placeholder="Enter price"
                                  value={item?.price2 ? item?.price2 : ""}
                                  type="number"
                                  onWheel={numberInputOnWheelPreventChange}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "price2",
                                      e.target.value
                                    )
                                  }
                                  min={0}
                                />
                              </td>

                              <td>
                                <FormControl
                                  placeholder="Enter price"
                                  value={item.price3 ? item.price3 : ""}
                                  type="number"
                                  onWheel={numberInputOnWheelPreventChange}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleItemInformationChange(
                                      index,
                                      "price3",
                                      e.target.value
                                    )
                                  }
                                />
                              </td>
                            </tr >
                          );
                        })}
                      {
                        selectedQuote?.selectedProcess === 1 ||
                          selectedQuote?.selectedProcess === 2 ? (
                          <>
                            <tr className="leadTimeRow">
                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>
                              <td id="leadTimeTitle">Lines Total</td>
                              <td></td>
                              <td>
                                {currencyFormatter(
                                  linesTotal[0] ? linesTotal[0].toFixed(2) : 0
                                )}
                              </td>
                              <td>
                                {currencyFormatter(
                                  linesTotal[1] ? linesTotal[1].toFixed(2) : 0
                                )}
                              </td>
                              <td>
                                {currencyFormatter(
                                  linesTotal[2] ? linesTotal[2].toFixed(2) : 0
                                )}
                              </td>
                            </tr>


                            <tr className="leadTimeRow">
                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>

                              <td>
                                <div onClick={() => {
                                  setIsCertificationModalOpen(true);
                                  window.scrollTo({ top: 0, behavior: 'smooth' });
                                }} className='flex items-center justify-center border py-2 px-4 rounded '>
                                  <EyeIcon additionalClass={'h-4'} />
                                  <p className="whitespace-nowrap text-[14px]">View Certifications  </p>
                                </div>
                              </td>
                              <td></td>
                              <td colSpan={3} className="relative">
                                <div >
                                  <FormControl
                                    type="number"
                                    style={{ width: "100%" }}
                                    className="text-center"
                                    onWheel={numberInputOnWheelPreventChange}
                                    value={
                                      selectedQuote?.orderCertificationsCost
                                        ? selectedQuote?.orderCertificationsCost
                                        : ""
                                    }
                                    placeholder="Charge"
                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    onChange={(e) =>
                                      handleCertificationCostChange(e.target.value)
                                    }
                                    min={0}
                                  />
                                </div>

                              </td>

                            </tr>

                            <tr className="leadTimeRow">

                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>
                              <td id="leadTimeTitle">Lead Time</td>
                              <td></td>
                              <td>
                                <FormControl
                                  type="text"
                                  onWheel={numberInputOnWheelPreventChange}
                                  style={{ width: "100%" }}
                                  value={leadTime[0] ? leadTime[0] : ""}
                                  placeholder="Days"
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) => handleLeadTimeChange(e, 0)}
                                />
                                <p
                                  style={{ marginLeft: "10px", fontSize: "14px" }}
                                >
                                  {/* {leadTime[0] ? `(${leadTime[0]} business days)` : "NA"}{" "} */}
                                </p>
                              </td>

                              <td>
                                <FormControl
                                  type="text"
                                  style={{ width: "100%" }}
                                  onWheel={numberInputOnWheelPreventChange}
                                  value={leadTime[1] ? leadTime[1] : ""}
                                  placeholder="Days"
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) => handleLeadTimeChange(e, 1)}
                                />
                                <p
                                  style={{ marginLeft: "10px", fontSize: "14px" }}
                                >
                                  {/* {leadTime[1] ? `(${leadTime[0]} business days)` : "NA"}{" "} */}

                                </p>
                              </td>

                              <td>
                                <FormControl
                                  type="text"
                                  style={{ width: "100%" }}
                                  onWheel={numberInputOnWheelPreventChange}
                                  value={leadTime[2] ? leadTime[2] : ""}
                                  placeholder="Days"
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) => handleLeadTimeChange(e, 2)}
                                />
                                {/* <p
                                style={{ marginLeft: "10px", fontSize: "14px" }}
                              >
                                {leadTime[2] ? `(${leadTime[0]} business days)` : "NA"}{" "}
                              </p> */}
                              </td>
                            </tr>

                            <tr className="leadTimeRow">
                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>
                              <td id="leadTimeTitle">Shipping </td>
                              <td></td>
                              <td>
                                <FormControl
                                  type="number"
                                  style={{ width: "100%" }}
                                  onWheel={numberInputOnWheelPreventChange}
                                  value={
                                    !Number.isNaN(selectedQuote?.shippingCharge1)
                                      ? selectedQuote?.shippingCharge1
                                      : null
                                  }
                                  placeholder="Shipping"
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleShippingChargeChange(e, 1)
                                  }
                                />
                              </td>

                              <td>
                                <FormControl
                                  type="number"
                                  style={{ width: "100%" }}
                                  onWheel={numberInputOnWheelPreventChange}
                                  value={
                                    !Number.isNaN(selectedQuote?.shippingCharge2)
                                      ? selectedQuote?.shippingCharge2
                                      : null
                                  }
                                  placeholder="Shipping"
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleShippingChargeChange(e, 2)
                                  }
                                />
                              </td>
                              <td>
                                <FormControl
                                  type="number"
                                  style={{ width: "100%" }}
                                  onWheel={numberInputOnWheelPreventChange}
                                  value={
                                    !Number.isNaN(selectedQuote?.shippingCharge3)
                                      ? selectedQuote?.shippingCharge3
                                      : null
                                  }
                                  placeholder="Shipping"
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) =>
                                    handleShippingChargeChange(e, 3)
                                  }
                                />
                              </td>
                            </tr>

                            <tr className="leadTimeRow">
                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>
                              <td id="leadTimeTitle">Shipping LeadTime</td>
                              <td></td>
                              <td>
                                <FormControl
                                  type="text"
                                  style={{ width: "100%" }}
                                  value={
                                    selectedQuote?.shippingDays1
                                      ? selectedQuote?.shippingDays1
                                      : ""
                                  }
                                  placeholder="Shipping days"
                                  min={0}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) => handleShippingLeadTimeChange(e, 0)}

                                />
                              </td>

                              <td>
                                <FormControl
                                  type="text"
                                  style={{ width: "100%" }}
                                  value={
                                    selectedQuote?.shippingDays2
                                      ? selectedQuote?.shippingDays2
                                      : ""
                                  }
                                  placeholder="Shipping days"
                                  min={0}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) => handleShippingLeadTimeChange(e, 1)}
                                />
                              </td>
                              <td>
                                <FormControl
                                  type="text"
                                  style={{ width: "100%" }}
                                  value={
                                    selectedQuote?.shippingDays3
                                      ? selectedQuote?.shippingDays3
                                      : ""
                                  }
                                  placeholder="Shipping days"
                                  min={0}
                                  onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) &&
                                    e.preventDefault()
                                  }
                                  onChange={(e) => handleShippingLeadTimeChange(e, 2)}
                                />
                              </td>
                            </tr>

                            <tr className="leadTimeRow">
                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>
                              <td id="leadTimeTitle">Total</td>
                              <td></td>
                              <td>
                                <h6>
                                  {currencyFormatter(
                                    linesTotal[0]
                                      ? (
                                        linesTotal[0] +
                                        parseFloat(selectedQuote?.shippingCharge1 || 0) + (selectedQuote?.orderCertificationsCost || 0)
                                      )
                                      : 0
                                  )}
                                </h6>
                              </td>

                              <td>
                                <h6>
                                  {currencyFormatter(
                                    linesTotal[1]
                                      ? (
                                        linesTotal[1] +
                                        parseFloat(selectedQuote?.shippingCharge2 || 0) + (selectedQuote?.orderCertificationsCost || 0)
                                      )
                                      : 0
                                  )}
                                </h6>
                              </td>

                              <td>
                                <h6>
                                  {currencyFormatter(linesTotal[2] ? (
                                    linesTotal[2] +
                                    parseFloat(selectedQuote?.shippingCharge3 || 0) + (selectedQuote?.orderCertificationsCost || 0)
                                  )
                                    : 0
                                  )}
                                </h6>
                              </td>
                            </tr>
                            {selectedQuote?.userTargetCost ? <tr className="leadTimeRow">
                              {selectedQuote?.partsData.length > 1 ? <td></td> : null}
                              <td></td>
                              <td></td>
                              <td id="leadTimeTitle">Requested Target Cost</td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>
                                <h6>
                                  {currencyFormatter(
                                    selectedQuote?.userTargetCost
                                      ? (
                                        selectedQuote?.userTargetCost
                                      ).toFixed(2)
                                      : 0
                                  )}
                                </h6>
                              </td>
                            </tr> : null}
                          </>
                        ) : null
                      }
                    </tbody >
                  </>
                )}
              </table >
              <div style={{ textAlign: "left", display: "flex", width: "100%" }}>
                <div style={{ width: "100%", flex: 1, marginRight: "10px" }}>
                  <h6 className="font-medium my-2">
                    Quotation Notes :&nbsp;&nbsp;
                  </h6>
                  <ReactQuill
                    value={quotationNotes}
                    onChange={(e) => {
                      setIsChanged({ ...isChanged, quotationNotes: true })
                      setQuotationNotes(e)
                    }}
                    placeholder="Enter notes here"
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      maxHeight: '300px',
                      overflow: 'auto'
                    }}
                  />
                </div>
                <div style={{ width: "100%", flex: 1 }}>
                  <h6 className="font-medium my-2">
                    Quotation Tnc :&nbsp;&nbsp;
                  </h6>
                  <ReactQuill
                    value={quotationTnc}
                    onChange={(e) => {
                      setIsChanged({ ...isChanged, quotationNotes: true })
                      setQuotationTnc(e)
                    }}
                    placeholder="Enter notes here"
                    style={{
                      width: "100%",
                      backgroundColor: "white",
                      maxHeight: '300px',
                      overflow: 'auto'
                    }}
                  />
                </div>
              </div>


              <div>
                <div className="quote-buttons admin-quote-buttons">
                  <button
                    className="update-button"
                    style={{ width: "180px" }}
                    onClick={handleUpdateQuotationNotesAndTnc}
                  >
                    Update Quote Note & TnC
                  </button>
                </div>
              </div>
              <div style={{ textAlign: "left" }}>
                <h6 className="font-medium my-2">
                  Admin Comments :&nbsp;&nbsp;
                </h6>
                <FormControl
                  as="textarea"
                  rows="3"
                  style={{ width: "100%" }}
                  placeholder="Enter comment here"
                  value={selectedQuote?.adminComment}
                  onChange={(e) =>
                    setSelectedQuote({
                      ...selectedQuote,
                      adminComment: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <div className="row quote-buttons admin-quote-buttons">
                  <button
                    className="update-button"
                    onClick={handleUpdateAdminComment}
                  >
                    Update Comment
                  </button>
                  {!selectedQuote?.isCancelled ? (
                    <>
                      <button
                        className="update-button"
                        style={{ leftMargin: "20px" }}
                        onClick={handleUpdateButtonClick}
                      >
                        Update
                      </button>
                      {selectedQuote?.isLogged && !selectedQuote?.myorders ?
                        <>
                          <button
                            className="update-button"
                            onClick={handleEditQuote}
                          >
                            Edit Quote{" "}
                          </button>
                        </> : <></>}


                      <select
                        name="download-quote-cost-select"
                        defaultValue=""
                        value={selectedShipMethod}
                        onChange={(e) => handleQuotePriceSelection(e)}
                        // className="download-quote-cost-select"
                        placeholder="Select price to download quote"
                        className="w-fit h-[30px] mt-[10px]  text-black bg-slate-200 border   rounded-sm"
                      >
                        <option disabled value="">
                          Select Cost
                        </option>
                        {linesTotal[0] ? <option className="hover:bg-primaryColor" value="1">
                          Rapid
                        </option> : null}
                        {linesTotal[1] ? < option className="hover:bg-primaryColor" value="2">
                          Standard
                        </option> : null}
                        {linesTotal[2] ? <option className="hover:bg-primaryColor" value="3">
                          Economy
                        </option> : null}
                      </select>

                      <button
                        className="update-button flex items-center justify-center "
                        onClick={ErrorCheckHOF(() => {
                          if (
                            isChanged.partInfo ||
                            isChanged.shippingCharge ||
                            isChanged.leadtime ||
                            isChanged.shippingDays
                            || isChanged.certifications
                          ) {
                            toast.error(
                              "Please update the quotation before downloading the quote."
                            );
                            return;
                          }

                          handleQMShowClick("download-quote");
                        })}
                      >
                        {!isQuotationDownloading ? (
                          <span>Download Quote</span>
                        ) : (
                          <LucidLoader additionalClass={"animate-spin"} />
                        )}
                      </button>
                      {selectedQuote?.isLogged ? <button
                        className="update-button flex items-center justify-center"
                        // onClick={handleSendEmail}
                        onClick={ErrorCheckHOF(() => {
                          if (
                            isChanged.partInfo ||
                            isChanged.shippingCharge ||
                            isChanged.leadtime ||
                            isChanged.shippingDays || isChanged.certifications
                          ) {
                            toast.error(
                              "Please update the quote."
                            );
                            return;
                          }
                          handleQMShowClick("send-to-email");
                        })}
                      >
                        {!isLoaderActive ? (
                          "Send To Email"
                        ) : (
                          <LucidLoader additionalClass={"animate-spin"} />
                        )}
                      </button> : null}

                      {selectedQuote?.isLogged && !selectedQuote?.isSent && !selectedQuote?.isEmailSent ? <button
                        className="update-button"
                        onClick={handleQuoteSend}
                      >
                        Mark as Sent
                      </button> : null}
                      {selectedQuote?.quoteEmailRecord ?
                        emailRecordLoading ? <button
                          className="update-button flex items-center justify-center"
                        >
                          <LucidLoader />
                        </button> : <button
                          className="update-button"
                          onClick={handleShowEmailRecordsClick}
                        >
                          Show email records
                        </button> : null}

                      {salesOrder?._id ? (
                        <>
                          <Link
                            to={`/admin/orders/${salesOrder?._id}`}
                            className="update-button flex items-center justify-center"
                          >
                            Go to SO
                          </Link>
                        </>
                      ) : (
                        <>

                          {selectedQuote?.isLogged ? <button
                            className="update-button"
                            onClick={handleProceedToSOModal}
                          >
                            Proceed to SO
                          </button> : null}
                        </>
                      )}
                      {
                        (name === allInstanceData?.NDCS)
                          ? (
                            selectedQuote?.isUpdatedByAdmin && (selectedQuote?.isSent || selectedQuote?.isEmailSent) &&
                            (!selectedQuote?.isTargetCostActivated && !selectedQuote?.myorders) &&
                            <button
                              onClick={() => setIsCaptchModalForAskTargetCost(true)}
                              className="update-button whitespace-nowrap"
                            >
                              Ask Target Cost
                            </button>
                          )
                          : (
                            ((selectedQuote?.price1 || selectedQuote?.price2 || selectedQuote?.price3)
                              && !selectedQuote?.isTargetCostActivated
                              && !selectedQuote?.myorders) ?
                              <button
                                onClick={() => setIsCaptchModalForAskTargetCost(true)}
                                className="update-button whitespace-nowrap"
                              >
                                Ask Target Cost
                              </button> : null

                          )
                      }


                      {selectedQuote?.isLogged ? <button className="update-button">
                        <div onClick={showDrawer}>
                          <ChatButton
                            RefId={selectedQuote?.RefId}
                            showDrawer={showDrawer}
                            color={"white"}
                          />
                        </div>
                      </button> : null}
                      {
                        !selectedQuote?.isLogged && !salesOrder?._id ? <button
                          onClick={() => setIsLoggedModalOpen(true)}
                          className="bg-primaryColor px-2 py-1 text-white rounded update-button"
                        >
                          Move out from unlogged state
                        </button> : !salesOrder?._id && !selectedQuote?.isTargetCostActivated ? <button
                          onClick={() => setIsLoggedModalOpen(true)}
                          className="bg-primaryColor px-2 py-1 text-white rounded update-button"
                        >
                          Move in unlogged state
                        </button> : null}


                      {!Array.isArray(rFQForQuotation) || rFQForQuotation.length === 0 ? (
                        <button className="update-button" onClick={() => setShowSendtoSupplierModal(true)}>
                          Send to Suppliers
                        </button>
                      ) : (
                        rFQForQuotation.map((item, index) => (
                          <Link
                            to={item.type === 'offer' ? `/admin/offers-details/${item._id}` : `/admin/rfq-details/${item._id}`}
                            key={index}
                            className="update-button"
                          // onClick={ErrorCheckHOF(() => handleGoToRFQClick(item.type, item._id))}
                          >
                            {item.type === 'offer' ? 'Go To Offer' : 'Go To RFQ'}
                          </Link>
                        ))
                      )}
                      {!isBatchFileDownloading ? <button
                        className="update-button !w-[300px] whitespace-nowrap"
                        onClick={handleExternalDownload}
                      >
                        Batch download all technical drawings
                        <BatchDownloadButton selectedQuote={selectedQuote} showButton={false} ref={batchRef} />
                      </button> : <button
                        className="update-button !w-[300px] whitespace-nowrap flex items-center justify-center"
                      >
                        <LucidLoader />
                      </button>}


                      <Modal
                        style={{
                          width: "500px",
                          margin: "auto",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%,-50%)",
                        }}
                        size="sm"
                        dialogClassName="qoute-version-modal"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={showSendtoSupplierModal}
                        onHide={() => setShowSendtoSupplierModal(false)}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: "15px" }}>
                            Choose Action
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="action-buttons flex ">
                            <Button className="req-quote-btn mx-1 whitespace-nowrap" onClick={() => handleCreateRFQ("offer")}>
                              Create Offer
                            </Button>
                            <Button className="req-quote-btn  whitespace-nowrap" onClick={() => handleCreateRFQ("rfq")}>
                              Create RFQ
                            </Button>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>

                        </Modal.Footer>
                      </Modal>
                      {selectedQuote?.userId?.companySiteId?.domain !== "*" ? (
                        teamLoading ? (
                          <button className="update-button flex items-center justify-center">
                            <LucidLoader />
                          </button>
                        ) : (
                          <button className="update-button" onClick={handleTeamModalShow}>
                            Team
                          </button>
                        )
                      ) : null}

                      <button
                        className="update-button"
                        onClick={handleCancelQuoteClick}
                      >
                        Cancel Quote{" "}
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="update-button"
                        onClick={handleMoveToProgress}
                      >
                        Move to Progress
                      </button>
                    </>
                  )}

                  <button className="update-button" onClick={ErrorCheckHOF(async () => await handleBack())}>
                    Back{" "}
                  </button>
                </div>
              </div>
            </div >
          ) : (
            <h5>Loading</h5>
          )}
        </div >
      </span >
    </div >
  );
};
export default AdminQuote;

